(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-button"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateBackLinks(root) {
      var links = root.querySelectorAll('[data-member-back-section] [data-member-back-link]');
      if (!links.length || !document.referrer) return;

      try {
        var source = new URL(document.referrer);
        var current = new URL(window.location.href);
        if (source.origin !== current.origin) return;
        if (source.pathname === current.pathname && source.search === current.search) return;

        for (var i = 0; i < links.length; i++) {
          links[i].href = source.href;
        }
      } catch (error) {
        // 來源不明時保留會員之家或自行指定的備援連結。
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        updateBackLinks(document);
      }, { once: true });
    } else {
      updateBackLinks(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      updateBackLinks(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-interaction-guard"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shopify-content-interaction-guard')) {
    customElements.define(
      'shopify-content-interaction-guard',
      class extends HTMLElement {
        connectedCallback() {
          if (this._cleanup) this._cleanup();

          const blockRightClick = this.dataset.blockRightClick === 'true';
          const blockClipboard = this.dataset.blockClipboard === 'true';
          const blockPrintScreen = this.dataset.blockPrintScreen === 'true';
          const listeners = [];

          const listen = (type, handler) => {
            document.addEventListener(type, handler, { capture: true });
            listeners.push([type, handler]);
          };

          const prevent = (event) => event.preventDefault();

          if (blockRightClick) {
            listen('contextmenu', prevent);
          }

          if (blockClipboard) {
            ['cut', 'copy', 'paste'].forEach((type) => {
              listen(type, prevent);
            });
          }

          if (blockClipboard || blockPrintScreen) {
            const handleRestrictedKeys = (event) => {
              const key = (event.key || '').toLowerCase();

              const isClipboardShortcut =
                blockClipboard &&
                event.type === 'keydown' &&
                (event.ctrlKey || event.metaKey) &&
                ['x', 'c', 'v'].includes(key);

              // 只嘗試取消收到的按鍵事件，不保證阻止系統截圖。
              const isPrintScreen =
                blockPrintScreen &&
                (key === 'printscreen' || event.code === 'PrintScreen');

              if (isClipboardShortcut || isPrintScreen) {
                event.preventDefault();
              }
            };

            listen('keydown', handleRestrictedKeys);
            listen('keyup', handleRestrictedKeys);
          }

          // 編輯器重新載入、移除區塊時，解除這個實例註冊的事件。
          this._cleanup = () => {
            listeners.forEach(([type, handler]) => {
              document.removeEventListener(type, handler, { capture: true });
            });
            this._cleanup = null;
          };
        }

        disconnectedCallback() {
          if (this._cleanup) this._cleanup();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-youtube-player"] && !Shopify.designMode) return;
  try {
    
function extractMemberYoutubeVideoId(input, depth){
  depth = depth || 0;
  if(depth > 4) return '';
  var value = String(input || '').trim().replace(/&amp;|&#0*38;|&#x0*26;/gi, '&');
  if(!value) return '';

  // Also accept the src from YouTube's copied iframe embed code.
  if(/<iframe\b/i.test(value)){
    var source = value.match(/\bsrc\s*=\s*["']([^"']+)["']/i);
    return source ? extractMemberYoutubeVideoId(source[1], depth + 1) : '';
  }
  value = value.replace(/^vnd\.youtube:(?:\/\/)?/i, '');
  var direct = value.match(/^([A-Za-z0-9_-]{11})(?=$|[/?#&])/);
  if(direct) return direct[1];

  // Decode a copied, fully encoded link; ordinary URL parameters are decoded below.
  if(/^(?:https?%(?:25)*3a|%(?:25)*2f)/i.test(value)){
    try{ return extractMemberYoutubeVideoId(decodeURIComponent(value), depth + 1); }
    catch(error){ return ''; }
  }

  var address = value;
  if(/^\/(?:watch(?:[/?#]|$)|(?:shorts|live|embed|v|e|video)\/)/i.test(value)){
    address = 'https://www.youtube.com' + value;
  } else if(value.indexOf('//') === 0){
    address = 'https:' + value;
  } else if(!/^https?:\/\//i.test(value)){
    address = 'https://' + value;
  }

  var link;
  try{ link = new URL(address); }catch(error){ return ''; }
  if(link.protocol !== 'https:' && link.protocol !== 'http:') return '';
  var hostname = link.hostname.toLowerCase();
  var shortLink = hostname === 'youtu.be' || hostname === 'www.youtu.be';
  var youtubeLink = hostname === 'youtube.com' || hostname.endsWith('.youtube.com');
  var embedLink = hostname === 'youtube-nocookie.com' || hostname === 'www.youtube-nocookie.com';
  if(!shortLink && !youtubeLink && !embedLink) return '';

  var path;
  try{ path = decodeURIComponent(link.pathname); }catch(error){ return ''; }
  if(youtubeLink && /^\/(?:attribution_link|redirect)\/?$/i.test(path)){
    var target = link.searchParams.get('u') || link.searchParams.get('q') || link.searchParams.get('url');
    if(!target || !/^(?:https?:\/\/|\/|https?%(?:25)*3a|%(?:25)*2f)/i.test(target)) return '';
    return extractMemberYoutubeVideoId(target, depth + 1);
  }
  var queryId = link.searchParams.get('v');
  if(queryId){
    var queryMatch = queryId.match(/^([A-Za-z0-9_-]{11})(?=$|[/?#&])/);
    if(queryMatch) return queryMatch[1];
  }
  // These embed endpoints identify a playlist or channel, not a video ID.
  if(!shortLink && /^\/embed\/(?:videoseries|live_stream)(?:\/|$)/i.test(path)) return '';
  var pathMatch = shortLink
    ? path.match(/^\/([A-Za-z0-9_-]{11})(?:\/|$)/)
    : path.match(/^\/(?:shorts|live|embed|v|e|video|watch|u\/\d+)\/([A-Za-z0-9_-]{11})(?:\/|$)/i);
  return pathMatch ? pathMatch[1] : '';
}

function loadMemberYoutubeApi(){
  if(window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
  if(window.__memberYoutubeApiPromise) return window.__memberYoutubeApiPromise;
  var pending = new Promise(function(resolve, reject){
    var pollTimer, waitTimer, script, created = false, finished = false;
    function finish(error){
      if(finished) return;
      finished = true;
      clearInterval(pollTimer);
      clearTimeout(waitTimer);
      if(script) script.removeEventListener('error', onError);
      if(error){
        if(created && script.parentNode) script.parentNode.removeChild(script);
        reject(error);
      } else resolve(window.YT);
    }
    function check(){
      if(window.YT && typeof window.YT.Player === 'function') finish();
    }
    function onError(){ finish(new Error('YouTube API could not be loaded.')); }
    script = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
    if(!script){
      script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      script.async = true;
      created = true;
    }
    script.addEventListener('error', onError, {once:true});
    pollTimer = setInterval(check, 100);
    waitTimer = setTimeout(function(){
      finish(new Error('YouTube API did not become ready.'));
    }, 20000);
    if(created) document.head.appendChild(script);
    check();
  });
  window.__memberYoutubeApiPromise = pending;
  pending.catch(function(){
    if(window.__memberYoutubeApiPromise === pending) window.__memberYoutubeApiPromise = null;
  });
  return pending;
}

function mountYoutubeSection(host){
  var pid = host.dataset.sectionId;
  var mount = host.querySelector('[data-youtube-id]');
  if(!mount) return;
  var videoId = extractMemberYoutubeVideoId(mount.getAttribute('data-youtube-id'));
  if(!videoId){
    var invalidStatus = host.querySelector('[data-yt-status]');
    if(invalidStatus){
      invalidStatus.textContent = '無法辨識 YouTube 影片 ID，請確認填入的是單一影片網址或影片 ID。';
      invalidStatus.hidden = false;
    }
    return;
  }
  mount.setAttribute('data-youtube-id', videoId);
  var ready = false, stopped = false, loading = false, timeoutTimer = null, retryTimer = null;
  var generation = 0, attempts = 0, maxAttempts = 3, pendingPlay = false;
  var listeners = new AbortController();
  function showStatus(message){
    var status = host.querySelector('[data-yt-status]');
    if(status){ status.textContent = message; status.hidden = !message; }
  }
  function listen(element, event, callback){
    element.addEventListener(event, callback, {signal:listeners.signal});
  }
  var player, btnPlay, btnMute, btnUnmute, seekBar, overlay, wrap, liveChip;
  var progressTimer=null, isSeeking=false, hover=false, liveCheckTimer=null;
  var viewportFullscreen = null;

  function isLive(){
    if(!ready || !player || typeof player.getVideoData !== 'function') return false;
    try{
      // A missing duration and a title containing LIVE do not establish a live broadcast.
      var data = player.getVideoData();
      return !!data && data.isLive === true;
    }catch(error){ return false; }
  }

  function init(){
    btnPlay   = document.getElementById("btnPlay-"+pid);
    btnMute   = document.getElementById("btnMute-"+pid);
    btnUnmute = document.getElementById("btnUnmute-"+pid);
    seekBar   = document.getElementById("seekBar-"+pid);
    overlay   = document.getElementById("ytOverlay-"+pid);
    wrap      = document.getElementById("ytWrap-"+pid);
    liveChip  = document.getElementById("ytLiveChip-"+pid);

    // Keep one set of controls when an unfinished player is rebuilt.
    listen(btnPlay, 'click', function(){
      if(!ready){
        pendingPlay = true;
        if(!loading && !retryTimer){ attempts = 0; startPlayer(); }
        return;
      }
      var st = player.getPlayerState();
      if(st === YT.PlayerState.PLAYING){
        player.pauseVideo();
      } else {
        player.playVideo();
      }
    });

    // 音量按鈕：手動切換並即時更新圖示
    listen(btnMute, 'click', function(){
      if(!ready) return;
      if(player.isMuted()) {
        player.unMute();
      } else {
        player.mute();
      }
      syncMuteButton(); // 立即同步圖示
    });

    if(btnUnmute) listen(btnUnmute, 'click', function(){
      if(!ready) return;
      player.unMute();
      syncMuteButton();
    });

    // 速度與進度條邏輯
    var btnSpeedUp = document.getElementById("btnSpeedUp-" + pid);
    var btnSpeedDown = document.getElementById("btnSpeedDown-" + pid);
    var speedDisplay = document.getElementById("speedDisplay-" + pid);
    var speeds = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
    function updateSpeed(delta) {
      if(!ready) return;
      var currentRate = player.getPlaybackRate();
      var currentIndex = speeds.indexOf(currentRate);
      if (currentIndex === -1) currentIndex = 3;
      var newIndex = Math.min(Math.max(currentIndex + delta, 0), speeds.length - 1);
      var newRate = speeds[newIndex];
      player.setPlaybackRate(newRate);
      speedDisplay.textContent = newRate + "x";
    }
    if(btnSpeedUp) listen(btnSpeedUp, 'click', function() { updateSpeed(1); });
    if(btnSpeedDown) listen(btnSpeedDown, 'click', function() { updateSpeed(-1); });

    var btnFs = document.getElementById("btnFs-"+pid);
    if(btnFs) listen(btnFs, 'click', toggleFullscreen);
    listen(document, 'fullscreenchange', syncFullscreenButton);
    listen(document, 'webkitfullscreenchange', syncFullscreenButton);
    listen(window, 'resize', updateViewportFullscreen);
    listen(window, 'orientationchange', updateViewportFullscreen);
    listen(window, 'pagehide', exitViewportFullscreen);
    if(window.visualViewport){
      listen(window.visualViewport, 'resize', updateViewportFullscreen);
      listen(window.visualViewport, 'scroll', updateViewportFullscreen);
    }
    listen(document, 'keydown', function(event){
      if(viewportFullscreen && event.key === 'Escape'){
        event.preventDefault();
        exitViewportFullscreen();
      }
    });

    listen(seekBar, 'input', function(){ isSeeking = true; });
    listen(seekBar, 'change', function(){
      if(!ready) return;
      player.seekTo(seekBar.value);
      isSeeking = false;
    });

    listen(wrap, 'mouseenter', ()=>{ hover=true; updateControlsVisibility(); });
    listen(wrap, 'mouseleave', ()=>{ hover=false; updateControlsVisibility(); });
  }

  function onPlayerReady(event) {
    if(stopped) return;
    player = event.target;
    ready = true;
    loading = false;
    clearTimeout(timeoutTimer);
    showStatus('');
    var live = isLive();
    var hint = document.getElementById("playHint-" + pid);

    if (live) {
      player.mute();
      player.playVideo();
    } else {
      player.unMute();
      player.setVolume(100);
      if (hint) {
        hint.style.display = 'block';
        hint.style.opacity = '1';
      }
      if(pendingPlay) player.playVideo();
    }
    pendingPlay = false;
    syncMuteButton();
    syncDuration();
    updateControlsVisibility();
    startLiveCheckTimer();
    syncFullscreenButton();
  }

  function onPlayerStateChange(e) {
    if(!ready || stopped) return;
    const isPlaying = (e.data === YT.PlayerState.PLAYING);
    if(isPlaying){
      var poster = host.querySelector('[data-yt-poster]');
      if(poster) poster.remove();
    }
    var icon = btnPlay.querySelector('.icon');
    icon.setAttribute('data-state', isPlaying ? 'pause' : 'play');
    var hint = document.getElementById("playHint-" + pid);
    if (hint) hint.style.display = isPlaying ? 'none' : 'block';
    if (isPlaying) startProgressTimer();
    else stopProgressTimer();
    syncMuteButton();
    updateControlsVisibility();
  }

  function resetPlayer(){
    clearTimeout(timeoutTimer);
    stopProgressTimer();
    clearInterval(liveCheckTimer);
    liveCheckTimer = null;
    var oldPlayer = player;
    player = null;
    if(oldPlayer && typeof oldPlayer.destroy === 'function'){
      try{ oldPlayer.destroy(); }catch(error){}
    }
    var oldFrame = host.querySelector('[id="ytPlayer-'+pid+'"]');
    if(oldFrame) oldFrame.remove();
    mount = document.createElement('div');
    mount.id = 'ytPlayer-'+pid;
    mount.setAttribute('data-youtube-id', videoId);
    wrap.insertBefore(mount, wrap.firstChild);
    isSeeking = false;
    wrap.classList.remove('is-live');
    if(liveChip) liveChip.style.display = 'none';
    overlay.classList.remove('hidden');
  }

  function retryPlayer(token){
    if(stopped || ready || token !== generation) return;
    generation++;
    loading = false;
    resetPlayer();
    if(attempts < maxAttempts){
      showStatus('播放器載入稍慢，正在重新嘗試…');
      retryTimer = setTimeout(function(){
        retryTimer = null;
        startPlayer();
      }, 400 * attempts);
    } else {
      showStatus('播放器連線未完成，請點左下角播放鍵重試。');
      var hint = document.getElementById('playHint-'+pid);
      if(hint){ hint.style.display = 'block'; hint.style.opacity = '1'; }
    }
  }

  function startPlayer(){
    if(stopped || ready || loading || !host.isConnected) return;
    var token = ++generation;
    attempts++;
    loading = true;
    if(player) resetPlayer();
    if(attempts === 1) showStatus('播放器載入中…');
    loadMemberYoutubeApi().then(function(){
      if(stopped || token !== generation || !host.isConnected) return;
      // Build a fresh iframe only after the API is available, with explicit page origin.
      timeoutTimer = setTimeout(function(){ retryPlayer(token); }, 12000);
      try {
        player = new YT.Player(mount, {
          host: 'https://www.youtube.com',
          videoId: videoId,
          playerVars: {
            enablejsapi: 1, controls: 0, disablekb: 1, modestbranding: 1,
            rel: 0, iv_load_policy: 3, fs: 1, playsinline: 1,
            origin: window.location.origin
          },
          events: {
            onReady: function(event){
              if(stopped || token !== generation) return;
              if(typeof event.target.getPlayerState !== 'function' ||
                 typeof event.target.getDuration !== 'function'){
                retryPlayer(token);
                return;
              }
              onPlayerReady(event);
            },
            onStateChange: function(event){
              if(token === generation) onPlayerStateChange(event);
            },
            onAutoplayBlocked: function(){
              if(stopped || token !== generation) return;
              var hint = document.getElementById('playHint-'+pid);
              if(hint){ hint.style.display = 'block'; hint.style.opacity = '1'; }
            },
            onError: function(event){
              if(stopped || token !== generation) return;
              clearTimeout(timeoutTimer);
              loading = false;
              showStatus('YouTube 無法播放這部影片（錯誤碼：'+event.data+'）。');
            }
          }
        });
        var frame = player.getIframe();
        frame.setAttribute('title', 'Member Video');
        frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        frame.setAttribute('allowfullscreen', '');
        frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      } catch(error){ retryPlayer(token); }
    }).catch(function(){ retryPlayer(token); });
  }

  host.disposeYoutube = function(){
    exitViewportFullscreen();
    stopped = true;
    ready = false;
    generation++;
    clearTimeout(timeoutTimer);
    clearTimeout(retryTimer);
    clearInterval(progressTimer);
    clearInterval(liveCheckTimer);
    listeners.abort();
    if(player && typeof player.destroy === 'function') player.destroy();
    player = null;
    // Leave a mount point for Shopify section reconnection.
    if(!host.querySelector('[id="ytPlayer-'+pid+'"]')){
      var replacement = document.createElement('div');
      replacement.id = 'ytPlayer-'+pid;
      replacement.setAttribute('data-youtube-id', videoId);
      wrap.insertBefore(replacement, wrap.firstChild);
    }
  };
  init();
  startPlayer();

  function updateControlsVisibility(){
    if(!ready || stopped || !player) return;
    var st = player.getPlayerState();
    var shouldShow = !!viewportFullscreen || isLive() || (st !== YT.PlayerState.PLAYING) || hover;
    overlay.classList.toggle('hidden', !shouldShow);
  }

  function startProgressTimer(){
    if(progressTimer) clearInterval(progressTimer);
    progressTimer = setInterval(function(){
      if(!ready || stopped || !player || isSeeking) return;
      seekBar.value = player.getCurrentTime();
      seekBar.max = player.getDuration();
    }, 500);
  }
  function stopProgressTimer(){ clearInterval(progressTimer); progressTimer = null; }

  function syncMuteButton(){
    if(!ready || stopped || !player) return;
    setTimeout(function() {
      if(!ready || stopped || !player) return;
      var icon = btnMute.querySelector('.icon');
      var isMuted = player.isMuted();
      icon.setAttribute('data-state', isMuted ? 'mute' : 'sound');
    }, 50);
  }

  function syncDuration(){
    if(!ready || stopped) return;
    var live = isLive();
    wrap.classList.toggle('is-live', live);
    if (liveChip) liveChip.style.display = live ? 'inline-flex' : 'none';
  }
  function startLiveCheckTimer(){
    clearInterval(liveCheckTimer);
    liveCheckTimer=setInterval(syncDuration, 2000);
  }

  function isFullscreen(){
    return !!(viewportFullscreen || document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  }
  function syncFullscreenButton(){
    var button = host.querySelector('[id="btnFs-'+pid+'"]');
    if(!button) return;
    button.title = isFullscreen() ? '退出全螢幕' : '全螢幕';
    button.setAttribute('aria-label', isFullscreen() ? '退出全螢幕' : '全螢幕/關閉全螢幕');
  }
  function updateViewportFullscreen(){
    if(!viewportFullscreen) return;
    var viewport = window.visualViewport;
    wrap.style.setProperty('--yt-fs-top', (viewport ? viewport.offsetTop : 0)+'px');
    wrap.style.setProperty('--yt-fs-left', (viewport ? viewport.offsetLeft : 0)+'px');
    wrap.style.setProperty('--yt-fs-width', (viewport ? viewport.width : window.innerWidth)+'px');
    wrap.style.setProperty('--yt-fs-height', (viewport ? viewport.height : window.innerHeight)+'px');
  }
  function enterViewportFullscreen(){
    if(stopped || viewportFullscreen || !host.isConnected) return;
    var state = viewportFullscreen = {x:window.scrollX, y:window.scrollY, hover:hover, styles:[], rootHadStyle:document.documentElement.hasAttribute('style')};
    function saveStyle(element, property, value){
      state.styles.push({element:element, property:property,
        value:element.style.getPropertyValue(property), priority:element.style.getPropertyPriority(property),
        hadStyle:element.hasAttribute('style')});
      if(value !== null) element.style.setProperty(property, value, 'important');
    }
    ['--yt-fs-top','--yt-fs-left','--yt-fs-width','--yt-fs-height'].forEach(function(property){ saveStyle(wrap, property, null); });
    // 暫時移除祖先的固定定位限制與層級限制，退出後逐項還原。
    for(var parent = wrap.parentElement; parent; parent = parent.parentElement){
      var style = window.getComputedStyle(parent);
      ['transform','perspective','filter','backdrop-filter','-webkit-backdrop-filter','contain'].forEach(function(property){
        var value = style.getPropertyValue(property);
        if(value && value !== 'none') saveStyle(parent, property, 'none');
      });
      if(style.willChange !== 'auto') saveStyle(parent, 'will-change', 'auto');
      if(style.contentVisibility && style.contentVisibility !== 'visible') saveStyle(parent, 'content-visibility', 'visible');
      if(style.isolation === 'isolate') saveStyle(parent, 'isolation', 'auto');
      if(style.zIndex !== 'auto' || style.position === 'fixed' || style.position === 'sticky') saveStyle(parent, 'z-index', '2147483647');
      if(Number(style.opacity) < 1) saveStyle(parent, 'opacity', '1');
    }
    saveStyle(document.documentElement, 'overflow', 'hidden');
    saveStyle(document.body, 'position', 'fixed');
    saveStyle(document.body, 'top', -state.y+'px');
    saveStyle(document.body, 'left', -state.x+'px');
    saveStyle(document.body, 'width', '100%');
    saveStyle(document.body, 'overflow', 'hidden');
    wrap.classList.add('yt-viewport-fullscreen');
    hover = true;
    updateViewportFullscreen();
    syncFullscreenButton();
    updateControlsVisibility();
  }
  function exitViewportFullscreen(){
    if(!viewportFullscreen) return;
    var state = viewportFullscreen;
    viewportFullscreen = null;
    wrap.classList.remove('yt-viewport-fullscreen');
    state.styles.reverse().forEach(function(saved){
      if(saved.value) saved.element.style.setProperty(saved.property, saved.value, saved.priority);
      else saved.element.style.removeProperty(saved.property);
      if(!saved.hadStyle && !saved.element.style.length) saved.element.removeAttribute('style');
    });
    var root = document.documentElement;
    var behavior = root.style.getPropertyValue('scroll-behavior');
    var priority = root.style.getPropertyPriority('scroll-behavior');
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(state.x, state.y);
    if(behavior) root.style.setProperty('scroll-behavior', behavior, priority);
    else root.style.removeProperty('scroll-behavior');
    if(!state.rootHadStyle && !root.style.length) root.removeAttribute('style');
    hover = state.hover;
    syncFullscreenButton();
    updateControlsVisibility();
  }
  function toggleFullscreen(){
    if(viewportFullscreen){ exitViewportFullscreen(); return; }
    if(isFullscreen()){
      var exit = document.exitFullscreen || document.webkitExitFullscreen || document.webkitCancelFullScreen;
      if(exit){
        try{
          var exiting = exit.call(document);
          if(exiting && typeof exiting.catch === 'function') exiting.catch(function(){});
        }catch(error){}
      }
      return;
    }
    var request = document.fullscreenEnabled !== false && wrap.requestFullscreen;
    if(!request && document.webkitFullscreenEnabled !== false) request = wrap.webkitRequestFullscreen || wrap.webkitRequestFullScreen;
    if(!request){ enterViewportFullscreen(); return; }
    try{
      var entering = request.call(wrap);
      if(entering && typeof entering.catch === 'function') entering.catch(enterViewportFullscreen);
    }catch(error){ enterViewportFullscreen(); }
  }
}
if(!customElements.get('member-youtube-section')){
  customElements.define('member-youtube-section', class extends HTMLElement {
    connectedCallback(){
      clearTimeout(this.mountTimer);
      this.mountTimer = setTimeout(() => {
        if(this.isConnected && !this.disposeYoutube) mountYoutubeSection(this);
      }, 0);
    }
    disconnectedCallback(){
      clearTimeout(this.mountTimer);
      if(this.disposeYoutube) this.disposeYoutube();
      this.disposeYoutube = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('main-product-swipe-gallery')) return;
  class MainProductSwipeGallery extends HTMLElement {
    connectedCallback() {
      if (this.events || this.readyFrame) return;
      this.readyFrame = requestAnimationFrame(() => {
        this.readyFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.events) return;
      this.track = this.querySelector('[data-product-gallery-track]');
      this.slides = Array.from(this.track?.querySelectorAll('[data-product-gallery-slide]') || []);
      this.controls = this.querySelector('[data-product-gallery-controls]');
      this.count = this.querySelector('[data-product-gallery-count]');
      if (!this.track || !this.controls || this.slides.length < 2) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.mobile = matchMedia('(max-width: 899px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = Math.max(0, this.slides.findIndex(slide => slide.hasAttribute('data-selected-media')));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.updateIndex(), 120);
      }, {passive: true, signal});
      this.querySelector('[data-product-gallery-prev]').addEventListener('click', () => this.move(-1), {signal});
      this.querySelector('[data-product-gallery-next]').addEventListener('click', () => this.move(1), {signal});
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      this.mobile.addEventListener('change', () => this.updateMode(), {signal});
      const resize = () => {
        if (this.width === this.track.clientWidth) return;
        this.width = this.track.clientWidth;
        if (this.mobile.matches) this.goTo(this.index, 'auto');
      };
      window.addEventListener('resize', resize, {passive: true, signal});
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(resize);
        this.observer.observe(this.track);
      }
      this.updateMode();
    }
    updateCount() {
      this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    updateMode() {
      clearTimeout(this.scrollTimer);
      this.controls.hidden = !this.mobile.matches;
      this.track.tabIndex = this.mobile.matches ? 0 : -1;
      this.width = this.track.clientWidth;
      if (this.mobile.matches) this.goTo(this.index, 'auto');
      else this.track.scrollLeft = 0;
      this.updateCount();
    }
    updateIndex() {
      if (!this.mobile.matches) return;
      const origin = this.slides[0].offsetLeft;
      let closest = 0;
      this.slides.forEach((slide, index) => {
        if (Math.abs(slide.offsetLeft - origin - this.track.scrollLeft) <
            Math.abs(this.slides[closest].offsetLeft - origin - this.track.scrollLeft)) closest = index;
      });
      this.index = closest;
      this.updateCount();
    }
    goTo(index, behavior = 'smooth') {
      this.index = index;
      this.track.scrollTo({left: this.slides[index].offsetLeft - this.slides[0].offsetLeft,
        behavior: this.reducedMotion.matches ? 'auto' : behavior});
      this.updateCount();
    }
    move(direction) {
      if (!this.mobile.matches) return;
      const target = (this.index + direction + this.slides.length) % this.slides.length;
      const wraps = Math.abs(target - this.index) > 1;
      this.goTo(target, wraps ? 'auto' : 'smooth');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.readyFrame);
      this.readyFrame = null;
      clearTimeout(this.scrollTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.events = null;
    }
  }
  customElements.define('main-product-swipe-gallery', MainProductSwipeGallery);
})();
(() => {
  if (customElements.get('tea-member-options')) return;
  class MemberOptions extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.section = this.closest('[data-product-section]');
      if (!this.section) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.placeWidget();
        });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.section, {childList: true, subtree: true});
      this.schedule();
    }
    placeWidget() {
      if (!this.isConnected) return;
      const selector = '[id^="appstle_membership_widget"]';
      const widgets = Array.from(this.section.querySelectorAll(selector));
      widgets.forEach(widget => {
        if (widget === this || widget.contains(this) || this.contains(widget)) return;
        if (widget.parentElement?.closest(selector)) return;
        this.appendChild(widget);
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.observer = null;
    }
  }
  customElements.define('tea-member-options', MemberOptions);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-or-bought-limit"] && !Shopify.designMode) return;
  try {
    
/* Local browser records shared by normal and fullscreen display modes. */
(() => {
  if (window.MemberContentRecords) return;
  const fields = ['reading_progress', 'listening_progress', 'content_bookmarks'];
  const services = new Map();
  const empty = () => ({v:1, entries:Object.create(null)});
  function unpack(value) {
    if (!value) return empty();
    if (value.v !== 1 || !value.entries || typeof value.entries !== 'object' || Array.isArray(value.entries)) throw new Error('Unsupported record format');
    const result = empty();
    for (const [key,entry] of Object.entries(value.entries)) {
      if (entry && typeof entry === 'object' && Number.isFinite(entry.t)) result.entries[key] = entry;
    }
    return result;
  }
  function canonicalSource(source) {
    const url = new URL(source, location.origin);
    url.hash = '';
    for (const key of [...url.searchParams.keys()]) {
      if (/^(?:token|expires|signature|policy|key-pair-id|_token|x-amz-.+|x-goog-.+)$/i.test(key)) url.searchParams.delete(key);
    }
    url.searchParams.sort();
    return url.href;
  }
  async function contentKey(product, source) {
    const digest = await crypto.subtle.digest('SHA-256',new TextEncoder().encode(canonicalSource(source)));
    return String(product) + ':' + Array.from(new Uint8Array(digest), n => n.toString(16).padStart(2,'0')).join('');
  }
  class RecordError extends Error { constructor(code) {super(code);this.code=code;} }
  function storageError(error) {
    return new RecordError(error && ['QuotaExceededError','NS_ERROR_DOM_QUOTA_REACHED'].includes(error.name) ? 'full' : 'storage-error');
  }
  class Service extends EventTarget {
    constructor(config) {
      super(); this.config=config; this.product=String(config.product); this.customer=String(config.customer);
      // Reuse local records from the previous player version without reading any account data.
      this.cacheKey='member-content-records-v1:' + config.shop + ':' + this.customer;
      this.roots=Object.fromEntries(fields.map(field => [field,empty()]));
      this.state='local'; this.lastStamp=0;
      try {this.readStored();} catch(error) {this.state=error.code;}
      this.pageEvents=new AbortController();
      window.addEventListener('storage',event => {
        if(event.key!==this.cacheKey && event.key!==null) return;
        try {this.readStored();this.notify('local');} catch(error) {this.notify(error.code);}
      },{signal:this.pageEvents.signal});
    }
    notify(state) {this.state=state;this.dispatchEvent(new Event('change'));}
    readStored() {
      let raw;
      try {raw=localStorage.getItem(this.cacheKey);} catch(error) {throw storageError(error);}
      try {
        const cached=raw===null ? null : JSON.parse(raw);
        if(cached && (cached.v!==1 || !cached.roots || typeof cached.roots!=='object')) throw new Error('Unsupported record format');
        const roots=Object.create(null);
        for(const field of fields) roots[field]=unpack(cached && cached.roots[field]);
        this.roots=roots;
      } catch(_) {throw new RecordError('error');}
    }
    field(kind) {return kind==='media' ? 'listening_progress' : 'reading_progress';}
    progress(kind,key) {return this.roots[this.field(kind)].entries[key] || null;}
    commit(field,entries) {
      const roots={...this.roots,[field]:{v:1,entries}};
      try {localStorage.setItem(this.cacheKey,JSON.stringify({v:1,roots}));}
      catch(error) {const failure=storageError(error);this.notify(failure.code);throw failure;}
      this.roots=roots;this.notify('local');
    }
    mutate(field,key,value) {
      // Read the latest browser copy before writing so other tabs' records are retained.
      try {this.readStored();} catch(error) {this.notify(error.code);throw error;}
      const existing=this.roots[field].entries[key];
      this.lastStamp=Math.max(Date.now(),this.lastStamp+1,existing ? existing.t+1 : 0);
      const entry={...value,t:this.lastStamp,rev:crypto.randomUUID()};
      this.commit(field,Object.assign(Object.create(null),this.roots[field].entries,{[key]:entry}));
      return entry;
    }
    saveProgress(kind,key,pos) {
      const old=this.progress(kind,key);
      if(old && JSON.stringify(old.pos)===JSON.stringify(pos)) return old;
      return this.mutate(this.field(kind),key,{kind,pos});
    }
    bookmarks(product) {
      return Object.values(this.roots.content_bookmarks.entries).filter(item => !item.deleted &&
        typeof item.key==='string' && item.key.startsWith(String(product)+':') && item.pos && item.id)
        .sort((a,b) => b.t-a.t);
    }
    addBookmark(context) {
      const id=crypto.randomUUID();
      return this.mutate('content_bookmarks',id,{id,key:context.key,kind:context.kind,
        label:String(context.label||'').slice(0,140),pos:context.pos,
        ...(context.kind==='epub' && context.detail ? {detail:{title:String(context.detail.title||'').slice(0,240),chapter:String(context.detail.chapter||'').slice(0,200),percentage:Number.isFinite(context.detail.percentage) ? context.detail.percentage : null,excerpt:String(context.detail.excerpt||'').slice(0,120)}} : {})});
    }
    removeBookmark(id) {
      try {this.readStored();} catch(error) {this.notify(error.code);throw error;}
      const entries=Object.assign(Object.create(null),this.roots.content_bookmarks.entries);
      if(!Object.prototype.hasOwnProperty.call(entries,id)) return;
      delete entries[id];this.commit('content_bookmarks',entries);
    }
  }
  const dictionaries={
    'zh-TW':{add:'加入書籤',bookmarks:'書籤',empty:'尚未加入書籤',remove:'刪除',
      error:'無法讀取紀錄，原有資料已保留。','storage-error':'此瀏覽器無法儲存紀錄。',
      full:'此瀏覽器儲存空間已滿，這次紀錄未儲存。','player-error':'無法取得播放進度，請重新載入再試。',
      jump:'無法開啟此書籤，請確認內容仍可使用。'},
    en:{add:'Add bookmark',bookmarks:'Bookmarks',empty:'No bookmarks yet',remove:'Delete',
      error:'Unable to read records. Existing data has been kept.','storage-error':'This browser cannot save records.',
      full:'Browser storage is full. This change was not saved.','player-error':'Unable to read playback progress. Please reload and try again.',
      jump:'Unable to open this bookmark. Check that its content is still available.'},
    'zh-CN':{add:'加入书签',bookmarks:'书签',empty:'尚未加入书签',remove:'删除',
      error:'无法读取记录，原有数据已保留。','storage-error':'此浏览器无法保存记录。',
      full:'此浏览器存储空间已满，这次记录未保存。','player-error':'无法取得播放进度，请重新加载再试。',
      jump:'无法打开此书签，请确认内容仍可使用。'}
  };
  class Tools {
    constructor(host,service,options) {
      this.service=service;this.options=options;this.words=dictionaries[service.config.language]||dictionaries['zh-TW'];
      this.events=new AbortController();const signal=this.events.signal;
      this.root=document.createElement('div');this.root.className='er-records';
      if(options.bookmarks) {
        if(service.config.bookmarkNote) {
          this.note=document.createElement('p');this.note.className='er-record-note';
          this.note.textContent=String(service.config.bookmarkNote);this.root.append(this.note);
        }
        this.add=document.createElement('button');this.add.type='button';this.add.textContent=this.words.add;this.add.disabled=true;
        this.details=document.createElement('details');this.details.className='er-bookmarks';
        const summary=document.createElement('summary');summary.textContent=this.words.bookmarks;summary.tabIndex=0;
        this.list=document.createElement('ol');this.details.append(summary,this.list);this.root.append(this.add,this.details);
        this.add.addEventListener('click',() => {
          const context=options.context();if(!context || !context.key || !context.pos) return;
          try {service.addBookmark(context);} catch(error) {this.showError(this.words[error.code]||this.words.error);}
        },{signal});
        this.list.addEventListener('click',async event => {
          const button=event.target.closest('button[data-bookmark-id]');if(!button) return;
          const item=service.bookmarks(service.product).find(value => value.id===button.dataset.bookmarkId);if(!item) return;
          if(button.dataset.action==='delete') {
            try {service.removeBookmark(item.id);} catch(error) {this.showError(this.words[error.code]||this.words.error);}
            return;
          }
          button.disabled=true;
          try {await options.jump(item);this.details.open=false;}
          catch (_) {this.showError(this.words.jump);}
          finally {button.disabled=false;}
        },{signal});
      }
      this.status=document.createElement('span');this.status.className='er-record-status';this.status.setAttribute('role','status');
      this.root.append(this.status);host.appendChild(this.root);
      service.addEventListener('change',() => this.render(),{signal});this.render();
    }
    showError(message) {this.status.textContent=message;this.status.hidden=false;this.root.hidden=false;}
    render() {
      const message=this.service.state==='local' ? '' : this.words[this.service.state]||this.words.error;
      this.status.textContent=message;this.status.hidden=!message;
      this.root.hidden=!this.options.bookmarks && !message;
      if(!this.list) return;
      this.list.replaceChildren();
      const items=this.service.bookmarks(this.service.product).filter(item => !this.options.accept || this.options.accept(item));
      if(!items.length) {const item=document.createElement('li');item.textContent=this.words.empty;this.list.appendChild(item);}
      for(const entry of items) {
        const li=document.createElement('li'),jump=document.createElement('button'),remove=document.createElement('button');
        const label=this.options.label ? this.options.label(entry) : entry.label;
        jump.type=remove.type='button';jump.dataset.bookmarkId=remove.dataset.bookmarkId=entry.id;
        jump.textContent=label;remove.textContent=this.words.remove;remove.dataset.action='delete';
        remove.setAttribute('aria-label',this.words.remove+' '+label);li.append(jump,remove);this.list.appendChild(li);
      }
    }
    ready(value) {if(this.add) this.add.disabled=!value;}
    destroy() {this.events.abort();this.root.remove();}
  }
  function service(id) {
    const element=document.getElementById(id);if(!element) return null;
    const config=JSON.parse(element.textContent),previous=services.get(id);
    if(previous && ['shop','customer','product','language','bookmarkNote'].every(key => previous.config[key]===config[key])) return previous;
    if(previous) previous.pageEvents.abort();
    const instance=new Service(config);services.set(id,instance);return instance;
  }
  window.MemberContentRecords={service,contentKey,canonicalSource,Tools,Service,RecordError,unpack};
})();

(() => {
  if (customElements.get('member-product-epub-reader')) return;
  let pdfDependencies;
  let pdfBase = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/';
  function loadPdfDependencies(text) {
    if (!pdfDependencies) pdfDependencies = (async () => {
      const sources = [
        'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/',
        'https://unpkg.com/pdfjs-dist@4.10.38/'
      ];
      let lastError;
      for (const base of sources) {
        try {
          const lib = await limitTime(import(base + 'legacy/build/pdf.min.mjs'),15000,text('pdf_timeout'));
          lib.GlobalWorkerOptions.workerSrc = base + 'legacy/build/pdf.worker.min.mjs';
          pdfBase = base;
          return lib;
        } catch (error) {lastError = error;}
      }
      throw lastError;
    })().catch(error => {pdfDependencies = null; throw error;});
    return pdfDependencies;
  }
  let dependencies;
  let fullscreenOwner = null;
  const limitTime = (promise, ms, message) => {
    let timer;
    return Promise.race([promise,new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(message)), ms);
    })]).finally(() => clearTimeout(timer));
  };
  function script(src, text) {
    return new Promise((resolve,reject) => {
      const element = document.createElement('script');
      const timer = setTimeout(() => {
        element.remove(); reject(new Error(text('ui_09')));
      },25000);
      element.src = src; element.async = true;
      element.onload = () => {clearTimeout(timer);resolve();};
      element.onerror = () => {clearTimeout(timer);element.remove();reject(new Error(text('ui_10')));};
      document.head.appendChild(element);
    });
  }
  function loadDependencies(text) {
    if (!dependencies) dependencies = (async () => {
      if (!window.JSZip) await script('https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js', text);
      if (!window.ePub) await script('https://cdn.jsdelivr.net/npm/epubjs@0.3.93/dist/epub.min.js', text);
      if (!window.ePub || !window.JSZip) throw new Error(text('ui_11'));
    })().catch(error => {dependencies = null;throw error;});
    return dependencies;
  }
  class EpubReader extends HTMLElement {
    text(key, values = {}) {
      if (!this.uiStrings) {
        try { this.uiStrings = JSON.parse(this.dataset.i18n || '{}'); }
        catch (_) { this.uiStrings = {}; }
      }
      const value = String(this.uiStrings[key] ?? '');
      return value.replace(/\[(\w+)\]/g, (match, name) =>
        Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected) return;
      this.events = new AbortController();
      this.shell = this.querySelector('.er-shell');
      this.ui = {};
      ['intro','start','status','workspace','controls','toc','font-controls','font-down','font-up','font-value','reset','fullscreen','viewport','left','right','center','prev','next','location','top','bottom','fs-hint','full-hint','theme'].forEach(key => {
        this.ui[key] = this.shell.querySelector('[data-' + key + ']');
      });
      this.remember = this.dataset.remember === 'true';
      this.font = Number(this.dataset.font) || 18;
      this.ready = false;
      const on = (el,name,fn) => el.addEventListener(name,fn,{signal:this.events.signal});
      this.setupProgressInput(on);
      on(this.ui.start,'click',() => this.start());
      on(this.ui.prev,'click',() => this.move('prev'));
      on(this.ui.next,'click',() => this.move('next'));
      on(this.ui.left,'click',() => this.move(this.rtl ? 'next' : 'prev'));
      on(this.ui.right,'click',() => this.move(this.rtl ? 'prev' : 'next'));
      on(this.ui.toc,'change',() => {if(this.ui.toc.value) this.navigate(() => this.rendition.display(this.ui.toc.value));});
      on(this.ui['font-down'],'click',() => this.changeFont(-2));
      on(this.ui['font-up'],'click',() => this.changeFont(2));
      on(this.ui.reset,'click',() => this.resetFont());
      on(this.ui.theme,'change',() => {this.applyTheme();this.savePosition();});
      on(this.ui.fullscreen,'click',() => this.toggleFullscreen());
      on(this.ui.center,'click',() => this.setMenu(!this.menuOpen));
      on(this.shell,'keydown',event => this.key(event));
      on(document,'fullscreenchange',() => this.fullscreenChanged());
      on(document,'webkitfullscreenchange',() => this.fullscreenChanged());
      on(window,'resize',() => this.scheduleResize());
      on(window,'orientationchange',() => this.scheduleResize(true));
      on(window,'scroll',() => this.queueReadingPosition());
      if(window.visualViewport) {
        on(window.visualViewport,'resize',() => {this.scheduleResize();this.queueReadingPosition();});
        on(window.visualViewport,'scroll',() => {this.syncMobileViewport();this.queueReadingPosition();});
      }
      this.bookIndex = '1';
      this.shell.querySelectorAll('[data-book-source]').forEach(button => {
        let name = '';
        try {
          name = new URL(button.dataset.bookSource, location.href).pathname.split('/').pop();
          try {name = decodeURIComponent(name);} catch (_) {}
        } catch (_) {}
        name = name.replace(/\.[^.]+$/, '') || this.text('ui_12');
        button.textContent = name;
        button.title = name;
      });
      on(this.shell,'click',event => {
        const button = event.target.closest('[data-book-source]');
        if (button) this.selectBook(button);
      });
      on(this.ui.viewport,'contextmenu',event => event.preventDefault());
      on(this.ui.viewport,'pointerdown',() => this.stopScreenScroll());
      on(this.ui.viewport,'click',event => {
        if(!this.full || this.isPdf || this.fixed) return;
        const rect=this.ui.viewport.getBoundingClientRect(),x=(event.clientX-rect.left)/rect.width;
        if(x>=.3 && x<=.7) this.setMenu(!this.menuOpen);
      });
      this.pdfTopToggle = document.createElement('button');
      this.pdfTopToggle.type = 'button'; this.pdfTopToggle.className = 'er-pdf-top-toggle';
      this.pdfTopToggle.textContent = this.text('pdf_show_top');
      this.pdfTopToggle.setAttribute('aria-expanded','false');
      this.ui.next.before(this.pdfTopToggle);
      on(this.pdfTopToggle,'click',() => this.setMenu(!this.menuOpen));
      this.pdfWidth = document.createElement('button');
      this.pdfWidth.type = 'button'; this.pdfWidth.hidden = true;
      this.pdfWidth.textContent = this.text('pdf_width');
      this.ui['font-controls'].appendChild(this.pdfWidth);
      on(this.pdfWidth,'click',() => this.fitPdf('width'));
      this.ui.viewport.tabIndex = 0;
      on(this.ui.viewport,'pointerdown',event => {
        if(!this.isPdf || !this.ready || event.pointerType !== 'mouse' || event.button !== 0) return;
        const box = this.ui.viewport;
        if(event.offsetX >= box.clientWidth || event.offsetY >= box.clientHeight) return;
        this.pdfDrag = {id:event.pointerId,x:event.clientX,y:event.clientY,left:box.scrollLeft,top:box.scrollTop};
        box.setPointerCapture(event.pointerId); box.classList.add('er-dragging');
        box.focus({preventScroll:true}); event.preventDefault();
      });
      on(this.ui.viewport,'pointermove',event => {
        if(!this.pdfDrag || this.pdfDrag.id !== event.pointerId) return;
        this.ui.viewport.scrollLeft = this.pdfDrag.left - event.clientX + this.pdfDrag.x;
        this.ui.viewport.scrollTop = this.pdfDrag.top - event.clientY + this.pdfDrag.y;
      });
      const releaseDrag = () => {this.pdfDrag=null;this.ui.viewport.classList.remove('er-dragging');};
      on(this.ui.viewport,'pointerup',releaseDrag);
      on(this.ui.viewport,'pointercancel',releaseDrag);
      on(this.ui.viewport,'lostpointercapture',releaseDrag);
      this.updateFont();
      this.recordReady=this.setupRecords();
      this.setupDiagnostics();
      on(document,'visibilitychange',() => {if(document.visibilityState==='hidden') this.savePosition();});
      on(window,'pagehide',() => this.savePosition());
      on(this.ui.viewport,'scroll',() => this.queuePdfScroll());
      this.ui.viewport.addEventListener('wheel',event => {
        if(!this.isPdf || !this.ready || this.navigating || this.reflowing || event.defaultPrevented || event.ctrlKey || event.metaKey) return;
        this.stopScreenScroll();const box=this.ui.viewport,unit=event.deltaMode===1 ? 24 : event.deltaMode===2 ? box.clientHeight : 1;
        event.preventDefault();
        if(event.shiftKey && !event.deltaX) box.scrollLeft+=event.deltaY*unit;
        else {box.scrollTop+=event.deltaY*unit;box.scrollLeft+=event.deltaX*unit;}
      },{passive:false,signal:this.events.signal});
    }
    async setupRecords() {
      try {
        this.records=window.MemberContentRecords && MemberContentRecords.service(this.dataset.recordsConfig);
        const buttons=[...this.shell.querySelectorAll('[data-book-source]')];
        this.bookKeys=new Map(await Promise.all(buttons.map(async button => [button.dataset.bookSource,
          await MemberContentRecords.contentKey(this.dataset.product,button.dataset.bookSource)])));
        if(!this.isConnected) return;
        if(this.remember && this.records) {
          let latest=null, chosen=null;
          for(const button of buttons) {
            const saved=this.records.progress('epub',this.bookKeys.get(button.dataset.bookSource));
            if(saved && (!latest || saved.t>latest.t)) {latest=saved;chosen=button;}
          }
          if(chosen) {
            this.dataset.source=chosen.dataset.bookSource;this.bookIndex=chosen.dataset.bookIndex;
            buttons.forEach(button => button.setAttribute('aria-pressed',String(button===chosen)));
          }
        }
        this.recordKey=this.bookKeys.get(this.dataset.source) || await MemberContentRecords.contentKey(this.dataset.product,this.dataset.source);
        if(this.records && this.dataset.manualBookmarks==='true') {
          this.recordTools=new MemberContentRecords.Tools(this.ui.top,this.records,{
            bookmarks:true,context:() => this.bookmarkContext(),jump:item => this.openBookmark(item),
            label:item => this.bookmarkLabel(item),
            accept:item => item.kind==='epub' || item.kind==='pdf'
          });
        }
      } catch(_) {this.records=null;}
    }
    setReaderStorageKey(format) {
      const legacy='member_'+(format==='pdf'?'pdf_v1:':'epub_v4:')+this.dataset.customer+':'+this.dataset.product+':'+this.dataset.source;
      this.storageKey=this.recordKey ? 'member_reader_v1:'+this.dataset.customer+':'+this.recordKey : legacy;
      try {
        if(this.storageKey!==legacy && !localStorage.getItem(this.storageKey)) {
          const value=localStorage.getItem(legacy);if(value) localStorage.setItem(this.storageKey,value);
        }
      } catch(_) {}
    }
    savedReaderPosition(kind) {
      if(this.pendingBookmark && this.pendingBookmark.key===this.recordKey && this.pendingBookmark.kind===kind) return this.pendingBookmark.pos;
      if(!this.remember) return null;
      const saved=this.records && this.records.progress(kind,this.recordKey);
      if(saved && saved.kind===kind && saved.pos) return saved.pos;
      try {
        const local=JSON.parse(localStorage.getItem(this.storageKey));
        if(kind==='pdf' && local && Number.isFinite(Number(local.page))) return {page:Number(local.page),x:Number(local.x)||0,y:Number(local.y)||0,...(local.atEnd===true ? {atEnd:true} : {})};
        if(kind==='epub' && local && typeof local.cfi==='string') return this.epubAnchor(local);
      } catch(_) {}
      return null;
    }
    epubAnchor(value) {
      if(typeof value==='string') value={cfi:value};
      if(!value || typeof value.cfi!=='string') return null;
      const anchor={cfi:value.cfi};if(value.atEnd===true) anchor.atEnd=true;
      if(Number.isFinite(value.imageOffset)) anchor.imageOffset=Math.round(Math.max(0,Math.min(1,value.imageOffset))*1000000)/1000000;
      return anchor;
    }
    readerPosition() {
      if(this.isPdf) {
        return this.readPdfPosition();
      }
      if(!this.reflowing && !this.anchorBusy && !this.restorationFailed && (!this.ready || !this.size || this.sameReaderSize(this.size,this.readerSize()))) {
        const aligned=this.alignedReaderPosition();if(aligned) return aligned;
        const actual=this.firstVisibleAnchor();if(actual) {this.currentAnchor=actual;return actual;}
      }
      const cfi=this.currentAnchor && this.currentAnchor.cfi || this.cfiAnchor || this.position && this.position.start && this.position.start.cfi;
      return this.epubAnchor(this.currentAnchor) || (cfi ? {cfi} : null);
    }
    bookmarkContext() {
      if(!this.ready || this.navigating || this.reflowing) return null;
      const position=this.readerPosition();if(!position) return null;
      if(!this.isPdf) {
        const detail=this.bookmarkDetails(position);
        return {key:this.recordKey,kind:'epub',pos:position,detail,label:this.formatBookmark(detail)};
      }
      const book=this.shell.querySelector('[data-book-source][aria-pressed="true"]');
      return {key:this.recordKey,kind:'pdf',pos:position,label:(book ? book.textContent.trim()+'\n':'')+this.text('pdf_location',{current:position.page,total:this.pdf.numPages})+'｜'+this.readingText('progress',{value:this.readingPercentage(position).toFixed(1)})};
    }
    async openBookmark(item) {
      if(!this.ready || this.navigating || this.reflowing) throw new Error('Reader busy');
      if(item.key!==this.recordKey) {
        const button=[...this.shell.querySelectorAll('[data-book-source]')].find(button => this.bookKeys.get(button.dataset.bookSource)===item.key);
        if(!button) throw new Error('Book is no longer listed');
        this.pendingBookmark=item;await this.selectBook(button);
        if(!this.ready) throw new Error('Book could not load');
        return;
      }
      if(this.isPdf && item.kind==='pdf') await this.navigate(() => this.renderPdf(item.pos.page,{position:item.pos}));
      else if(!this.isPdf && item.kind==='epub' && item.pos.cfi) await this.navigate(() => {
        this.currentAnchor=item.pos;this.cfiAnchor=item.pos.cfi;return this.displayEpubAnchor(item.pos);
      });
      else throw new Error('Bookmark format does not match');
    }
    setupDiagnostics() {
      if(this.dataset.readerDiagnostics!=='true') return;
      this.diagnosticSamples=[];
      const panel=document.createElement('div');panel.className='er-reader-debug';
      const record=document.createElement('button'),copy=document.createElement('button'),status=document.createElement('output'),fallback=document.createElement('pre');
      record.type='button';record.textContent='記錄目前尺寸';copy.type='button';copy.textContent='複製尺寸診斷';fallback.hidden=true;
      this.diagnosticStatus=status;
      record.addEventListener('click',() => this.recordDiagnostic('手動取樣'),{signal:this.events.signal});
      copy.addEventListener('click',async () => {
        this.recordDiagnostic('複製時取樣');
        const value=JSON.stringify({build:'reader-stability-1',host:location.host,userAgent:navigator.userAgent,samples:this.diagnosticSamples},null,2);
        try {await navigator.clipboard.writeText(value);status.textContent='已複製，請貼回對話';fallback.hidden=true;}
        catch(_) {fallback.textContent=value;fallback.hidden=false;status.textContent='請長按下方資料複製';}
      },{signal:this.events.signal});
      panel.append(record,copy,status,fallback);this.ui.top.appendChild(panel);
    }
    recordDiagnostic(label) {
      if(!this.diagnosticSamples) return;
      const number=value => Number.isFinite(value) ? Math.round(value*100)/100 : null;
      const rect=element => {
        if(!element) return null;
        const box=element.getBoundingClientRect();
        return {left:number(box.left),top:number(box.top),right:number(box.right),bottom:number(box.bottom),width:number(box.width),height:number(box.height),
          clientWidth:element.clientWidth,clientHeight:element.clientHeight,scrollWidth:element.scrollWidth,scrollHeight:element.scrollHeight};
      };
      const view=window.visualViewport,manager=this.rendition && this.rendition.manager;
      const frames=Array.from(this.ui.viewport.querySelectorAll('iframe')).map(frame => {
        const result={frame:rect(frame),styleWidth:frame.style.width};
        try {
          const doc=frame.contentDocument,style=doc && doc.body && frame.contentWindow.getComputedStyle(doc.body);
          result.document=doc && rect(doc.documentElement);result.body=doc && rect(doc.body);
          result.innerWidth=frame.contentWindow.innerWidth;
          result.font=style && style.fontSize;result.textSizeAdjust=style && style.webkitTextSizeAdjust;
        } catch(_) {result.documentUnavailable=true;}
        return result;
      });
      this.diagnosticSamples.push({label,time:new Date().toISOString(),full:Boolean(this.full),native:Boolean(this.native),font:this.font,pdf:Boolean(this.isPdf),
        window:{width:innerWidth,height:innerHeight,devicePixelRatio:window.devicePixelRatio,scrollX,scrollY},
        document:rect(document.documentElement),visualViewport:view ? {width:number(view.width),height:number(view.height),scale:number(view.scale),left:number(view.offsetLeft),top:number(view.offsetTop)} : null,
        shell:rect(this.shell),workspace:rect(this.ui.workspace),viewport:rect(this.ui.viewport),
        engineSize:manager && manager._stageSize ? {width:manager._stageSize.width,height:manager._stageSize.height} : null,frames});
      if(this.diagnosticSamples.length>16) this.diagnosticSamples.splice(1,1);
      this.diagnosticStatus.textContent='已保留 '+this.diagnosticSamples.length+' 次尺寸記錄';
    }
    readerSize() {return [this.ui.viewport.clientWidth,this.ui.viewport.clientHeight];}
    sameReaderSize(a,b) {return a && b && Math.abs(a[0]-b[0])<1 && Math.abs(a[1]-b[1])<1;}
    syncEpubViewSizes() {
      const manager=this.rendition && this.rendition.manager;
      if(this.isPdf || this.fixed || !manager || !manager.views || manager.settings.axis!=='vertical') return false;
      const [width,height]=this.readerSize();
      if(width<1 || height<1) return false;
      const views=manager.views.all().filter(view => view.displayed && view.iframe && view.settings.axis==='vertical');
      const stale=views.filter(view => Math.abs(view.iframe.clientWidth-width)>=1 || Math.abs(view.settings.width-width)>=1);
      if(!stale.length) return false;
      // A resized layout can retain a view's old width lock. Resize the actual
      // iframe through the pinned EPUB view API before restoring source text.
      manager.updateLayout();
      for(const view of stale) {
        view.size(width,height);
        view.setLayout(manager.layout);
      }
      return true;
    }
    queueReadingPosition() {
      if(!this.ready || this.reflowing || this.anchorBusy || this.navigating || this.restorationFailed) return;
      cancelAnimationFrame(this.rememberFrame);
      this.rememberFrame=requestAnimationFrame(() => {
        this.rememberFrame=null;
        if(!this.ready || this.reflowing || this.anchorBusy || this.navigating || this.restorationFailed) return;
        if(this.size && !this.sameReaderSize(this.size,this.readerSize())) {this.scheduleResize();return;}
        this.readerPosition();if(this.isPdf) this.queuePdfScroll();else this.updateReadingLabel();
        clearTimeout(this.rememberTimer);
        this.rememberTimer=setTimeout(() => this.savePosition(),120);
      });
    }
    syncMobileViewport() {
      const mobile=this.full && !window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      this.shell.classList.toggle('er-mobile-full',mobile);
      if(!mobile) {
        for(const key of ['left','top','width','height']) this.shell.style.removeProperty('--er-screen-'+key);
        return;
      }
      const view=window.visualViewport;
      // Pinch zoom magnifies the existing layout; do not counteract it by reflowing.
      if(view && Math.abs(view.scale-1)>.02) return;
      const bounds={left:view ? view.offsetLeft : 0,top:view ? view.offsetTop : 0,
        width:view ? view.width : document.documentElement.clientWidth,height:view ? view.height : window.innerHeight};
      for(const [key,value] of Object.entries(bounds)) if(Number.isFinite(value) && (key==='left' || key==='top' || value>0)) {
        this.shell.style.setProperty('--er-screen-'+key,value+'px');
      }
    }
    visibleReaderBounds() {
      const view=window.visualViewport,top=view ? view.offsetTop : 0,left=view ? view.offsetLeft : 0;
      return {top:Math.max(top,this.full ? top : this.readerHeaderBottom()),left,
        bottom:top+(view ? view.height : window.innerHeight),right:left+(view ? view.width : window.innerWidth)};
    }
    readerHeaderBottom() {
      let bottom=window.visualViewport ? window.visualViewport.offsetTop : 0;
      for(const header of document.querySelectorAll('header,sticky-header,[role="banner"],.shopify-section-group-header-group')) {
        const style=getComputedStyle(header),rect=header.getBoundingClientRect();
        if((style.position==='fixed' || style.position==='sticky') && style.visibility!=='hidden' && style.display!=='none' &&
          rect.top<=bottom+1 && rect.bottom>bottom && rect.width>document.documentElement.clientWidth/2) bottom=rect.bottom;
      }
      return bottom;
    }
    scrollReaderIntoView() {
      if(!this.returnToReader || this.full || !this.isConnected) return;
      const root=document.documentElement,behavior=root.style.scrollBehavior;
      root.style.scrollBehavior='auto';
      const button=this.ui.fullscreen.getBoundingClientRect();
      const row=Array.from(this.ui.controls.children).map(element => element.getBoundingClientRect())
        .filter(rect => rect.height>0 && rect.bottom>button.top+1 && rect.top<button.bottom-1);
      const top=Math.min(button.top,...row.map(rect => rect.top)),offset=this.readerHeaderBottom()+8;
      if(Math.abs(top-offset)>1) window.scrollTo({left:window.scrollX,top:Math.max(0,window.scrollY+top-offset),behavior:'instant'});
      root.style.scrollBehavior=behavior;
    }
    concealLayout() {
      cancelAnimationFrame(this.revealFrame);
      this.shell.classList.add('er-layout-pending');
    }
    finishLayout() {
      cancelAnimationFrame(this.revealFrame);
      this.revealFrame=requestAnimationFrame(() => {
        this.revealFrame=null;
        if(!this.ready || this.resizeTask || this.resizeTimer || this.entering || this.exiting) return;
        this.syncMobileViewport();
        if(this.size && !this.sameReaderSize(this.size,this.readerSize())) {this.scheduleResize(true);return;}
        if(this.syncEpubViewSizes()) {this.scheduleResize(true);return;}
        this.reflowing=false;this.layoutAnchor=null;this.returnToReader=false;

        this.shell.classList.remove('er-layout-pending');
        this.savePosition();
        if(!this.isPdf && this.rendition && !this.restorationFailed) {
          const value=this.rendition.currentLocation();if(value && value.start) this.relocated(value);
        }
        this.updateButtons();
        if(this.isPdf) {this.paintPdfWindow();this.queuePdfScroll();}else this.queueEpubWindow();
        this.recordDiagnostic(this.full ? '全螢幕排版完成' : '一般模式排版完成');
      });
    }
    beginLayoutChange() {
      this.stopScreenScroll();clearTimeout(this.epubPruneTimer);
      if(!this.ready || !this.rendition) return;
      if(!this.reflowing) {
        
        this.layoutAnchor=this.readerPosition();
        this.savePosition();
      }
      if(this.layoutAnchor && this.layoutAnchor.cfi) {this.currentAnchor=this.layoutAnchor;this.cfiAnchor=this.layoutAnchor.cfi;}
      clearTimeout(this.rememberTimer);cancelAnimationFrame(this.rememberFrame);
      this.reflowing=true;
      this.concealLayout();
      if(this.recordTools) this.recordTools.ready(false);
      this.updateButtons();
    }
    resizeReader(width,height) {
      if(!this.ready || !this.rendition) return Promise.resolve();
      if(this.resizeTask) {this.queuedResize=[width,height];return this.resizeTask;}
      const task=this.reflowReader(width,height).finally(() => {
        if(this.resizeTask!==task) return;
        this.resizeTask=null;
        const queued=this.queuedResize;this.queuedResize=null;
        if(queued && this.ready && this.isConnected) this.resizeReader(...queued);
        else this.finishLayout();
      });
      this.resizeTask=task;return task;
    }
    async reflowReader(width,height) {
      const rendition=this.rendition,token=this.token;
      const position=this.layoutAnchor || this.readerPosition();
      if(position && position.cfi) {this.currentAnchor=position;this.cfiAnchor=position.cfi;}
      this.reflowing=true;this.updateButtons();
      try {
        this.scrollReaderIntoView();
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if(this.rendition!==rendition || this.token!==token || !this.isConnected) return;
        this.syncMobileViewport();
        [width,height]=this.readerSize();this.size=[width,height];
        if(this.isPdf) await this.renderPdf(this.pdfPage,{preserve:true,position});
        else {
          if(this.epubWindowTask) await limitTime(this.epubWindowTask,15000,this.text('ui_33'));
          rendition.resize(width,height,position && position.cfi);
          if(rendition.q && rendition.q.enqueue) await limitTime(rendition.q.enqueue(() => {}),15000,this.text('ui_33'));
          this.syncEpubViewSizes();
          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          if(position && position.cfi) await limitTime(this.displayEpubAnchor(position),15000,this.text('ui_33'));
          this.scrollReaderIntoView();
          await new Promise(resolve => requestAnimationFrame(resolve));
        }
        this.restorationFailed=false;
      } catch(_) {this.restorationFailed=true;if(this.isConnected) this.message(this.text('ui_33'),true);}
      finally {
        if(this.rendition===rendition && this.token===token) {
          // The frozen source position is released only after all queued layouts finish.
          this.updateButtons();
        }
      }
    }

    lineClass() {return 'member-reader-line-anchor';}
    caretVisibleAnchor(contents,clip,bounds,frame) {
      const doc=contents.document,win=doc.defaultView,body=doc.body;
      if(!doc.caretRangeFromPoint && !doc.caretPositionFromPoint) return null;
      const sx=bounds.width/(frame.clientWidth||bounds.width||1),sy=bounds.height/(frame.clientHeight||bounds.height||1);
      const top=(clip.top-bounds.top)/sy,bottom=(clip.bottom-bounds.top)/sy,left=(clip.left-bounds.left)/sx,right=(clip.right-bounds.left)/sx;
      const style=win.getComputedStyle(body),bodyRect=body.getBoundingClientRect(),start=Math.max(left,bodyRect.left+(parseFloat(style.paddingLeft)||0))+1;
      const font=parseFloat(style.fontSize)||this.font||18;
      const pointRange=(x,y) => {
        if(doc.caretRangeFromPoint) return doc.caretRangeFromPoint(x,y);
        const point=doc.caretPositionFromPoint(x,y);if(!point) return null;
        const range=doc.createRange();range.setStart(point.offsetNode,point.offset);range.collapse(true);return range;
      };
      const glyphRange=(node,at) => {
        at=Math.max(0,Math.min(node.length-1,at));
        if(at>0 && /[\uDC00-\uDFFF]/.test(node.textContent[at])) at--;
        const range=doc.createRange();range.setStart(node,at);range.setEnd(node,Math.min(node.length,at+1));return range;
      };
      for(const y of [top+1,top+font*.65,top+font*1.8,top+font*3.6,top+font*7.2]) {
        if(y>=bottom) break;
        for(const x of [Math.min(right-1,start),left+(right-left)*.12,left+(right-left)*.5]) {
          const caret=pointRange(x,y),node=caret && caret.startContainer;
          if(!node || node.nodeType!==3 || !node.length || !node.textContent.trim() || node.parentElement.closest('script,style,noscript,svg,rt,.'+this.lineClass())) continue;
          let range=glyphRange(node,caret.startOffset),rect=range.getBoundingClientRect();
          if(rect.width<.1 || rect.bottom<=top+.5 || rect.top>=bottom-.5) continue;
          const block=node.parentElement.closest('p,li,h1,h2,h3,h4,h5,h6,blockquote,div')||node.parentElement;
          const walker=doc.createTreeWalker(block,4);let text,count=0,found=null;
          while((text=walker.nextNode()) && count++<64) {
            if(!text.textContent.trim() || text.parentElement.closest('script,style,noscript,svg,rt,.'+this.lineClass())) continue;
            const scan=doc.createRange();scan.selectNodeContents(text);
            const line=Array.from(scan.getClientRects()).find(r => r.width>.1 && Math.min(r.bottom,rect.bottom)-Math.max(r.top,rect.top)>Math.min(r.height,rect.height)*.35);
            if(!line) continue;
            let lo=0,hi=text.length;
            while(lo<hi) {const mid=(lo+hi)>>1;const g=glyphRange(text,mid).getBoundingClientRect();if(g.bottom<=line.top+.5) lo=mid+1;else hi=mid;}
            for(let at=lo;at<Math.min(text.length,lo+40);at++) {
              const candidate=glyphRange(text,at),g=candidate.getBoundingClientRect();if(g.top>=line.bottom-.5) break;
              if(!/\s/.test(text.textContent[at]) && g.width>.1 && g.right>left && g.left<right && g.bottom>top+.5) {found=candidate;break;}
            }
            if(found) break;
          }
          range=found||range;rect=range.getBoundingClientRect();range.collapse(true);
          return {cfi:contents.cfiFromRange(range,this.lineClass()),y:bounds.top+rect.top*sy};
        }
      }
      return null;
    }
    firstVisibleAnchor() {
      if(this.isPdf || !this.rendition || !this.rendition.getContents) return null;
      const viewport=this.ui.viewport.getBoundingClientRect(),visible=this.visibleReaderBounds();
      const clip={top:Math.max(viewport.top,visible.top),bottom:Math.min(viewport.bottom,visible.bottom),left:Math.max(viewport.left,visible.left),right:Math.min(viewport.right,visible.right)};
      if(clip.bottom<=clip.top || clip.right<=clip.left) return null;
      let best=null;
      for(const contents of this.rendition.getContents()) {
        const doc=contents.document,frame=doc.defaultView && doc.defaultView.frameElement;if(!frame || !doc.body) continue;
        if(this.fixed || doc.defaultView.getComputedStyle(doc.body).writingMode.startsWith('vertical')) return this.fallbackVisibleAnchor();
        const bounds=frame.getBoundingClientRect();if(bounds.bottom<=clip.top || bounds.top>=clip.bottom || bounds.right<=clip.left || bounds.left>=clip.right) continue;
        const text=this.caretVisibleAnchor(contents,clip,bounds,frame);
        if(text && (!best || Math.max(clip.top,text.y)<Math.max(clip.top,best.y)-1)) best=text;
        const sx=bounds.width/(frame.clientWidth||bounds.width||1),sy=bounds.height/(frame.clientHeight||bounds.height||1);
        for(const image of doc.body.querySelectorAll('img,svg')) {
          if(image.parentElement.closest('svg')) continue;
          const r=image.getBoundingClientRect(),y=bounds.top+r.top*sy;
          if(r.width<=1 || r.height<=1 || bounds.top+r.bottom*sy<=clip.top+.5 || y>=clip.bottom-.5 || bounds.left+r.right*sx<=clip.left || bounds.left+r.left*sx>=clip.right) continue;
          if(!best || Math.max(clip.top,y)<Math.max(clip.top,best.y)-1) best={cfi:contents.cfiFromNode(image,this.lineClass()),y,imageOffset:(clip.top-y)/(r.height*sy)};
        }
      }
      if(!best) return this.fallbackVisibleAnchor();
      if(this.atBookEnd(clip,viewport)) best.atEnd=true;
      return this.epubAnchor(best);
    }

    fallbackVisibleAnchor() {
      if(this.isPdf || !this.rendition || !this.rendition.getContents || !this.ui.viewport.getBoundingClientRect) return null;
      const viewport=this.ui.viewport.getBoundingClientRect();
      const visible=this.visibleReaderBounds();
      const clip={top:Math.max(visible.top,viewport.top),bottom:Math.min(visible.bottom,viewport.bottom),
        left:Math.max(visible.left,viewport.left),right:Math.min(visible.right,viewport.right)};
      if(clip.bottom<=clip.top || clip.right<=clip.left) return null;
      let best=null;
      for(const contents of this.rendition.getContents()) {
        const doc=contents.document,frame=doc.defaultView && doc.defaultView.frameElement;
        if(!frame || !doc.body) continue;
        const bounds=frame.getBoundingClientRect();
        if(bounds.bottom<=clip.top || bounds.top>=clip.bottom || bounds.right<=clip.left || bounds.left>=clip.right) continue;
        const sx=bounds.width/(frame.clientWidth||bounds.width||1),sy=bounds.height/(frame.clientHeight||bounds.height||1);
        const trackImages=!this.fixed && !getComputedStyle(doc.body).writingMode.startsWith('vertical');
        const top=(clip.top-bounds.top)/sy,bottom=(clip.bottom-bounds.top)/sy;
        const left=(clip.left-bounds.left)/sx,right=(clip.right-bounds.left)/sx;
        const walker=doc.createTreeWalker(doc.body,4),range=doc.createRange();let node;
        while((node=walker.nextNode())) {
          if(!node.textContent.trim() || node.parentElement.closest('script,style,noscript,rt,.'+this.lineClass())) continue;
          if(trackImages && node.parentElement.closest('svg')) continue;
          range.selectNodeContents(node);
          const line=Array.from(range.getClientRects()).find(rect => rect.height>.5 && rect.width>.1 && rect.bottom>top+.5 && rect.top<bottom-.5 && rect.right>left && rect.left<right);
          if(!line) continue;
          let lo=0,hi=node.length;
          while(lo<hi) {
            const mid=(lo+hi)>>1;range.setStart(node,mid);range.setEnd(node,Math.min(node.length,mid+1));
            const rect=range.getBoundingClientRect();
            if(rect.bottom<=line.top+.5) lo=mid+1;else hi=mid;
          }
          let offset=lo,rect;
          while(offset<node.length) {
            range.setStart(node,offset);range.setEnd(node,offset+1);rect=range.getBoundingClientRect();
            if(rect.top>line.bottom) break;
            if(!/\s/.test(node.textContent[offset]) && rect.width>.1 && rect.bottom>top+.5 && rect.right>left && rect.left<right) break;
            offset++;
          }
          if(offset>=node.length || !rect || rect.top>line.bottom) continue;
          if(offset>0 && /[\uDC00-\uDFFF]/.test(node.textContent[offset]) && /[\uD800-\uDBFF]/.test(node.textContent[offset-1])) offset--;
          const y=bounds.top+rect.top*sy;
          if(best && y>=best.y-1) continue;
          range.setStart(node,offset);range.collapse(true);
          best={cfi:contents.cfiFromRange(range,this.lineClass()),y,text:node.textContent.slice(offset,offset+70)};
        }
        if(!best || trackImages) for(const image of doc.body.querySelectorAll('img,svg')) {
          if(image.parentElement.closest('svg')) continue;
          const rect=image.getBoundingClientRect(),y=bounds.top+rect.top*sy;
          if(rect.width>1 && rect.height>1 && bounds.top+rect.bottom*sy>clip.top+.5 && y<clip.bottom-.5 &&
            bounds.left+rect.right*sx>clip.left && bounds.left+rect.left*sx<clip.right) {
            if(best && Math.max(clip.top,y)>=Math.max(clip.top,best.y)-1) continue;
            best={cfi:contents.cfiFromNode(image,this.lineClass()),y};
            if(trackImages) best.imageOffset=(clip.top-y)/(rect.height*sy);
            else break;
          }
        }
      }
      if(best && this.atBookEnd(clip,viewport)) best.atEnd=true;
      return this.epubAnchor(best);
    }
    clearLineMarkers() {
      if(!this.rendition || !this.rendition.getContents) return;
      for(const contents of this.rendition.getContents()) for(const marker of contents.document.querySelectorAll('.'+this.lineClass())) {
        const parent=marker.parentNode;marker.remove();parent.normalize();
      }
    }
    async waitEpubLayout(rendition) {
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if(this.fixed || this.rendition!==rendition || !rendition.getContents) return;
      const pending=[],cleanup=[];let closed=false;
      const loaded=image => new Promise(resolve => {
        const done=() => {image.removeEventListener('load',done);image.removeEventListener('error',done);resolve();};
        cleanup.push(done);image.addEventListener('load',done);image.addEventListener('error',done);
        if(image.complete) done();
      });
      try {
        for(const contents of rendition.getContents()) {
          const doc=contents.document;
          for(const image of doc.images) {
            if(image.complete || (!image.getAttribute('src') && !image.getAttribute('srcset'))) continue;
            if(image.loading==='lazy') image.loading='eager';
            pending.push(typeof image.decode==='function' ? image.decode().catch(() => closed || image.complete ? undefined : loaded(image)) : loaded(image));
          }
          if(doc.fonts && doc.fonts.status==='loading') pending.push(doc.fonts.ready.catch(() => {}));
        }
        if(pending.length) {
          try {await limitTime(Promise.all(pending),8000,this.text('ui_33'));}
          catch(error) {error.readerAssets=true;throw error;}
          if(this.rendition!==rendition) return;
          for(const contents of rendition.getContents()) if(contents.expand) contents.expand();
          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        }
      } finally {closed=true;for(const done of cleanup) done();}
    }
    async displayEpubAnchor(anchor) {
      const rendition=this.rendition;if(!rendition) return;
      const position=this.epubAnchor(anchor),cfi=position && position.cfi;let complete=false;
      this.anchorBusy=true;this.alignedAnchor=null;
      if(position) {this.currentAnchor=position;this.cfiAnchor=position.cfi;}
      try {
        this.clearLineMarkers();
        await rendition.display(cfi || undefined);
        this.syncEpubViewSizes();await this.waitEpubLayout(rendition);
        if(this.rendition!==rendition) return;
        if(position && !this.fixed && rendition.manager && rendition.manager.scrollBy) {
          // Restore the natural line containing the source character; never alter the book's DOM wrapping.
          for(let pass=0;pass<3;pass++) {
            const geometry=this.anchorGeometry(position);if(!geometry) break;
            const top=Math.max(this.visibleReaderBounds().top,this.ui.viewport.getBoundingClientRect().top),delta=geometry.y-top;
            if(!Number.isFinite(delta) || Math.abs(delta)<.75) break;
            rendition.manager.scrollBy(0,delta,true);
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          }
          const geometry=this.anchorGeometry(position);
          if(geometry) this.alignedAnchor={pos:position,relativeTop:geometry.y-Math.max(this.visibleReaderBounds().top,this.ui.viewport.getBoundingClientRect().top)};
        }
        if(rendition.reportLocation) await rendition.reportLocation();
        await new Promise(resolve => requestAnimationFrame(resolve));complete=true;
      } finally {
        if(this.rendition===rendition) {
          this.anchorBusy=false;
          if(complete && this.ready && !this.reflowing) {
            try {const current=await rendition.currentLocation();if(current && current.start) this.relocated(current);} catch(_) {}
            this.savePosition();
          }
        }
      }
    }
    readingText(key,values={}) {
      const words={
        'zh-TW':{progress:'閱讀進度：[value] %',loading:'正在計算閱讀進度…',input:'輸入閱讀百分比',go:'前往',apply:'修改',cancel:'取消',invalid:'請輸入 0～100，最多一位小數。',image:'圖片位置',previous:'上一畫面',next:'下一畫面',hint:'連續捲動閱讀｜上下捲動查看內容；全螢幕時點中央空白區開啟選單。',menu:'點中央空白區開闔選單',scroll:'上下捲動閱讀'},
        en:{progress:'Reading progress: [value] %',loading:'Calculating reading progress…',input:'Enter reading percentage',go:'Go',apply:'Apply',cancel:'Cancel',invalid:'Enter 0–100 with up to one decimal place.',image:'Image position',previous:'Previous screen',next:'Next screen',hint:'Continuous reading | Scroll to read. In fullscreen, tap the center to open the menu.',menu:'Tap the center to toggle the menu',scroll:'Scroll to read'},
        'zh-CN':{progress:'阅读进度：[value] %',loading:'正在计算阅读进度…',input:'输入阅读百分比',go:'前往',apply:'修改',cancel:'取消',invalid:'请输入 0～100，最多一位小数。',image:'图片位置',previous:'上一画面',next:'下一画面',hint:'连续滚动阅读｜上下滚动查看内容；全屏时点中央空白区打开菜单。',menu:'点中央空白区开关菜单',scroll:'上下滚动阅读'}
      };
      return String((words[this.dataset.language]||words['zh-TW'])[key]||'').replace(/\[(\w+)\]/g,(all,name) => values[name]??all);
    }
    setupProgressInput(on) {
      const form=document.createElement('form');form.className='er-progress-form';form.noValidate=true;
      const label=document.createElement('label'),caption=document.createElement('span'),input=document.createElement('input');
      caption.textContent=this.readingText('progress',{value:'\uFFF0'}).split('\uFFF0')[0];
      input.type='number';input.min='0';input.max='100';input.step='0.1';input.required=true;input.inputMode='decimal';input.placeholder='—';
      input.dataset.progressInput='';input.setAttribute('aria-label',this.readingText('input'));
      label.append(caption,input,document.createTextNode(' %'));
      const actions=document.createElement('span'),go=document.createElement('button'),cancel=document.createElement('button'),error=document.createElement('span');
      actions.className='er-progress-actions';actions.hidden=true;go.type='submit';go.textContent=this.readingText('apply');go.dataset.progressApply='';
      cancel.type='button';cancel.textContent=this.readingText('cancel');cancel.dataset.progressCancel='';
      error.className='er-progress-error';error.setAttribute('role','alert');error.hidden=true;actions.append(go,cancel,error);
      form.append(label,actions);this.ui.location.replaceChildren(form);
      this.progressForm=form;this.progressInput=input;this.progressActions=actions;this.progressError=error;
      const begin=() => {
        if(!this.ready || this.navigating || this.reflowing || !(this.isPdf ? this.pdf : this.progressIndex)) return;
        this.stopScreenScroll();
        if(!this.progressEditing) {input.value=(this.readingPercentage(this.readerPosition())??0).toFixed(1);error.hidden=true;}
        this.progressEditing=true;actions.hidden=false;
      };
      on(input,'focus',begin);on(input,'input',() => {begin();error.hidden=true;});
      on(cancel,'click',() => {this.cancelProgressEdit();input.blur();});
      on(form,'keydown',event => {if(event.key==='Escape') {event.preventDefault();event.stopPropagation();this.cancelProgressEdit();input.blur();}});
      on(form,'submit',async event => {
        event.preventDefault();if(!this.ready || this.navigating || this.reflowing) return;
        if(!input.checkValidity() || !Number.isFinite(input.valueAsNumber)) {error.textContent=this.readingText('invalid');error.hidden=false;input.focus();return;}
        const target=this.isPdf ? this.pdfAnchorAtPercentage(input.valueAsNumber) : this.anchorAtPercentage(input.valueAsNumber);if(!target) return;
        this.progressEditing=false;actions.hidden=true;error.hidden=true;
        await this.navigate(() => this.isPdf ? this.renderPdf(target.page,{position:target}) : this.displayEpubAnchor(target));
        input.blur();this.updateReadingLabel();
      });
      this.updateReadingLabel();
    }
    cancelProgressEdit() {
      this.progressEditing=false;if(this.progressActions) this.progressActions.hidden=true;if(this.progressError) this.progressError.hidden=true;
      this.updateReadingLabel();
    }
    atBookEnd(clip,viewport) {
      if(this.fixed || !this.book || !this.rendition || !this.rendition.manager) return false;
      const manager=this.rendition.manager,box=manager.container,views=manager.views && manager.views.all();
      const last=this.book.spine.spineItems.filter(section => section.linear).at(-1),tail=views && views.at(-1);
      return Boolean(last && tail && tail.displayed && tail.section.index===last.index && box && box.scrollHeight>0 &&
        box.scrollTop+box.clientHeight>=box.scrollHeight-2 && clip.bottom>=viewport.bottom-1);
    }
    pointCfi(cfi) {
      const point=new window.ePub.CFI(cfi);if(point.range) point.collapse(true);return point;
    }
    async buildProgressIndex(book) {
      const entries=[],chapters=[];let total=0;
      const links=this.chapterLinks||[],sections=book.spine.spineItems.filter(section => section.linear);
      for(const section of sections) {
        if(this.book!==book || !this.isConnected) return null;
        const root=await limitTime(section.load(book.load.bind(book)),15000,this.text('ui_33'));
        if(this.book!==book || !this.isConnected) return null;
        const doc=root.ownerDocument,body=doc.querySelector('body')||root;
        const walk=doc.createTreeWalker(body,5,{acceptNode:node => {
          if(node.nodeType===3) return node.textContent.trim() ? 1 : 3;
          if(node.matches('script,style,noscript,rt,[hidden],[aria-hidden="true"]')) return 2;
          return node.matches('img,svg,video,canvas') ? 1 : 3;
        }});
        let node;
        while((node=walk.nextNode())) {
          if(node.parentElement.closest('svg,video,canvas,script,style,noscript,rt,[hidden],[aria-hidden="true"]')) continue;
          const media=node.nodeType===1,text=media ? '' : node.textContent,units=media ? 1000 : text.length;
          if(!units) continue;
          let cfi;
          if(media) cfi=section.cfiFromElement(node);
          else {const range=doc.createRange();range.setStart(node,0);range.collapse(true);cfi=section.cfiFromRange(range);}
          entries.push({cfi,text,media,units,start:total,index:section.index});total+=units;
        }
        for(const link of links) {
          const target=book.spine.get(link.href);if(!target || target.index!==section.index) continue;
          let id=link.href.split('#')[1];try {if(id) id=decodeURIComponent(id);} catch(_) {}
          const element=id ? doc.getElementById(id) : body;
          if(element) chapters.push({cfi:section.cfiFromElement(element),label:link.label,index:section.index});
        }
        // Keep the index as source data, without holding every chapter DOM in memory.
        section.unload();
        await new Promise(resolve => setTimeout(resolve,0));
      }
      if(!entries.length || !total) return null;
      const compare=new window.ePub.CFI().compare;
      chapters.sort((a,b) => compare(a.cfi,b.cfi));
      return {entries,total,chapters};
    }
    progressEntry(position) {
      if(!position || !position.cfi || !this.progressIndex) return null;
      try {
        const point=this.pointCfi(position.cfi),entries=this.progressIndex.entries,compare=new window.ePub.CFI().compare;
        let lo=0,hi=entries.length;
        while(lo<hi) {const mid=(lo+hi)>>1;if(compare(entries[mid].cfi,point)<=0) lo=mid+1;else hi=mid;}
        const entry=entries[Math.max(0,lo-1)],start=this.pointCfi(entry.cfi);
        const same=point.spinePos===start.spinePos && JSON.stringify(point.path.steps.map(step => [step.type,step.index]))===JSON.stringify(start.path.steps.map(step => [step.type,step.index]));
        const offset=entry.media ? (same ? Math.max(0,Math.min(1,position.imageOffset||0))*entry.units : 0) : (same ? Math.max(0,Math.min(entry.units,point.path.terminal.offset||0)) : (compare(point,start)>0 ? entry.units : 0));
        return {entry,offset,index:Math.max(0,lo-1)};
      } catch(_) {return null;}
    }
    readingPercentage(position) {
      if(this.isPdf) return position && this.pdf ? (position.atEnd ? 100 : Math.max(0,Math.min(100,100*(position.page-1+(position.y||0))/this.pdf.numPages))) : null;
      const found=this.progressEntry(position);if(!found) return null;
      if(position.atEnd) return 100;
      return Math.max(0,Math.min(100,100*(found.entry.start+found.offset)/this.progressIndex.total));
    }
    anchorAtPercentage(value) {
      if(!this.progressIndex || !Number.isFinite(value) || value<0 || value>100) return null;
      const {entries,total}=this.progressIndex,target=value/100*total;
      let lo=0,hi=entries.length;
      while(lo<hi) {const mid=(lo+hi)>>1;if(entries[mid].start<=target) lo=mid+1;else hi=mid;}
      const entry=entries[Math.max(0,lo-1)],offset=Math.max(0,Math.min(entry.units,target-entry.start));
      if(entry.media) return {cfi:entry.cfi,imageOffset:offset/entry.units,...(value===100 ? {atEnd:true} : {})};
      const cfi=this.pointCfi(entry.cfi);let at=Math.round(offset);
      if(at>0 && /[\uDC00-\uDFFF]/.test(entry.text[at]||'')) at--;
      cfi.path.terminal.offset=at;return {cfi:cfi.toString(),...(value===100 ? {atEnd:true} : {})};
    }
    updateReadingLabel() {
      if(!this.progressInput) return;
      const percentage=this.readingPercentage(this.readerPosition());
      if(!this.progressEditing) this.progressInput.value=percentage===null ? '' : percentage.toFixed(1);
      this.progressInput.disabled=!this.ready || percentage===null;
      this.progressInput.setAttribute('aria-busy',String(Boolean(this.navigating || this.reflowing || this.progressLoading)));
      if(this.progressActions) this.progressActions.querySelector('[type="submit"]').disabled=Boolean(this.navigating || this.reflowing);
    }
    startProgressIndex() {
      const book=this.book;if(!book || this.isPdf || this.progressLoading || this.progressIndex) return;
      this.progressLoading=true;this.updateReadingLabel();
      this.buildProgressIndex(book).then(index => {
        if(this.book!==book || !this.isConnected) return;
        this.progressIndex=index;this.progressLoading=false;this.updateReadingLabel();if(this.recordTools) this.recordTools.render();
      }).catch(() => {if(this.book===book && this.isConnected) {this.progressLoading=false;this.updateReadingLabel();}});
    }
    bookmarkDetails(position) {
      const book=this.shell.querySelector('[data-book-source][aria-pressed="true"]'),found=this.progressEntry(position);
      let chapter='';
      if(this.progressIndex && position && position.cfi) {
        const compare=new window.ePub.CFI().compare;
        for(const item of this.progressIndex.chapters) {if(compare(item.cfi,position.cfi)>0) break;chapter=item.label;}
      }
      if(!chapter) {const selected=this.ui.toc.selectedOptions && this.ui.toc.selectedOptions[0];if(selected && selected.value) chapter=selected.textContent.trim();}
      let excerpt='';
      if(found) {
        if(found.entry.media) excerpt=this.readingText('image');
        else {
          const pieces=[found.entry.text.slice(Math.floor(found.offset))];
          for(let i=found.index+1;i<this.progressIndex.entries.length && pieces.join('').length<80;i++) {
            const next=this.progressIndex.entries[i];if(next.media || next.index!==found.entry.index) break;pieces.push(next.text);
          }
          const text=pieces.join(' ').replace(/\s+/g,' ').trim(),chars=Array.from(text);
          excerpt=chars.slice(0,30).join('')+(chars.length>30 ? '…' : '');
        }
      }
      return {title:book ? book.textContent.trim() : this.text('ui_12'),chapter,percentage:this.readingPercentage(position),excerpt};
    }
    formatBookmark(detail) {
      const progress=Number.isFinite(detail.percentage) ? this.readingText('progress',{value:detail.percentage.toFixed(1)}) : '';
      return [detail.title,[detail.chapter,progress].filter(Boolean).join('｜'),detail.excerpt].filter(Boolean).join('\n');
    }
    bookmarkLabel(item) {
      if(item.kind!=='epub') return item.label;
      if(item.key===this.recordKey && this.progressIndex && item.pos && item.pos.cfi) return this.formatBookmark(this.bookmarkDetails(item.pos));
      return item.detail ? this.formatBookmark(item.detail) : item.label;
    }
    anchorGeometry(position) {
      if(!position || !position.cfi || !this.rendition || !this.rendition.getRange) return null;
      try {
        const range=this.rendition.getRange(position.cfi,this.lineClass());if(!range) return null;
        const doc=range.startContainer.ownerDocument,frame=doc.defaultView && doc.defaultView.frameElement;if(!frame) return null;
        const target=range.cloneRange(),element=range.startContainer.nodeType===1 ? range.startContainer : null;
        const child=element && (element.matches('img,svg,video,canvas') ? element : element.childNodes[range.startOffset]);
        const media=child && child.nodeType===1 && child.matches('img,svg,video,canvas') ? child : null;
        if(media) target.selectNode(media);
        else if(range.startContainer.nodeType===3) {
          const text=range.startContainer,start=Math.min(range.startOffset,Math.max(0,text.length-1));
          target.setStart(text,start);target.setEnd(text,Math.min(text.length,start+1));
        }
        const bounds=frame.getBoundingClientRect(),rect=target.getBoundingClientRect(),scale=bounds.height/(frame.clientHeight||bounds.height||1);
        const offset=media && Number.isFinite(position.imageOffset) ? position.imageOffset*rect.height : 0;
        return {y:bounds.top+(rect.top+offset)*scale,media};
      } catch(_) {return null;}
    }
    alignedReaderPosition() {
      if(!this.alignedAnchor) return null;
      const geometry=this.anchorGeometry(this.alignedAnchor.pos),viewport=this.ui.viewport.getBoundingClientRect();
      const top=Math.max(this.visibleReaderBounds().top,viewport.top);
      if(geometry && Math.abs(geometry.y-top-this.alignedAnchor.relativeTop)<1.5) return this.epubAnchor(this.alignedAnchor.pos);
      this.alignedAnchor=null;return null;
    }
    bindContinuousContents(contents) {
      const doc=contents.document;if(!this.boundEpubDocuments) this.boundEpubDocuments=new WeakSet();
      if(this.boundEpubDocuments.has(doc)) return;this.boundEpubDocuments.add(doc);
      const controller=new AbortController(),bookSignal=(this.bookEvents||this.events).signal,stop=() => controller.abort();
      bookSignal.addEventListener('abort',stop,{once:true});
      controller.signal.addEventListener('abort',() => bookSignal.removeEventListener('abort',stop),{once:true});
      doc.defaultView.addEventListener('unload',stop,{once:true});
      let down=null,moved=false;const options={passive:true,signal:controller.signal};
      // Wheel events inside an iframe do not consistently scroll its outer reading surface.
      doc.addEventListener('wheel',event => {
        const manager=this.rendition && this.rendition.manager;
        if(!this.ready || this.navigating || this.reflowing || !manager || manager.settings.axis!=='vertical' ||
          event.defaultPrevented || event.ctrlKey || event.metaKey || Math.abs(event.deltaX)>Math.abs(event.deltaY)) return;
        this.stopScreenScroll();event.preventDefault();
        const unit=event.deltaMode===1 ? this.font*1.8 : event.deltaMode===2 ? this.ui.viewport.clientHeight : 1;
        manager.container.scrollTop+=event.deltaY*unit;
      },{passive:false,signal:controller.signal});
      doc.addEventListener('pointerdown',event => {this.stopScreenScroll();down={x:event.clientX,y:event.clientY};moved=false;},options);
      doc.addEventListener('pointermove',event => {if(down && Math.hypot(event.clientX-down.x,event.clientY-down.y)>8) moved=true;},options);
      doc.addEventListener('pointercancel',() => {moved=true;down=null;},options);
      doc.addEventListener('click',event => {
        if(!this.full || this.fixed || moved || event.defaultPrevented || event.target.closest('a,button,input,select,textarea,[contenteditable]')) return;
        const selection=doc.getSelection();if(selection && !selection.isCollapsed) return;
        const frame=doc.defaultView.frameElement,bounds=frame.getBoundingClientRect(),viewport=this.ui.viewport.getBoundingClientRect();
        const x=bounds.left+event.clientX*(bounds.width/(frame.clientWidth||bounds.width||1))-viewport.left;
        if(x>=viewport.width*.3 && x<=viewport.width*.7) this.setMenu(!this.menuOpen);
      },{signal:controller.signal});
    }

    showEpubView(view,manager) {
      if(!this.epubDisplays || this.epubManager!==manager) return Promise.resolve();
      let pending=this.epubDisplays.get(view);
      if(!pending) {
        pending=view.display(manager.request).then(() => {
          if(this.epubManager===manager && manager.views.all().includes(view)) view.show();
        }).finally(() => {if(this.epubDisplays && this.epubDisplays.get(view)===pending) this.epubDisplays.delete(view);});
        this.epubDisplays.set(view,pending);
      }
      return pending;
    }
    setupEpubWindow() {
      const manager=this.rendition && this.rendition.manager;
      if(this.fixed || !manager || this.epubManager===manager) return;
      this.epubManager=manager;this.epubDisplays=new Map();
      const originalUpdate=manager.update.bind(manager),originalTrim=manager.trim && manager.trim.bind(manager);
      const originalDisplay=manager.display.bind(manager);
      manager.display=async (section,target) => {
        const view=manager.views && manager.views.find(section);
        if(view && !view.displayed) await this.showEpubView(view,manager);
        return originalDisplay(section,target);
      };
      manager.settings.offset=Math.max(1800,this.ui.viewport.clientHeight*3);manager.settings.afterScrolledTimeout=100;
      manager.update=async offset => {
        if(manager.settings.axis!=='vertical') return originalUpdate(offset);
        const bounds=manager.bounds(),buffer=Math.max(manager.settings.offset,offset||0),jobs=[];
        for(const view of manager.views.all()) {
          if(!manager.isVisible(view,buffer,buffer,bounds)) continue;
          if(view.displayed && view.contents) {view.show();continue;}
          jobs.push(this.showEpubView(view,manager));
        }
        await Promise.all(jobs);
        if(this.epubManager!==manager) return;
        clearTimeout(this.epubPruneTimer);
        this.epubPruneTimer=setTimeout(() => {
          if(this.epubManager!==manager || this.reflowing || this.anchorBusy || this.navigating) return;
          const currentBounds=manager.bounds(),keep=Math.max(2400,this.ui.viewport.clientHeight*4);
          for(const view of manager.views.all()) {
            // Recheck at execution time. A queued old offscreen decision must never destroy the current page.
            if(view.displayed && !this.epubDisplays.has(view) && !manager.isVisible(view,keep,keep,currentBounds)) view.destroy();
          }
        },350);
      };
      // Empty view containers retain their measured heights, so fast reverse scrolling has stable geometry.
      manager.trim=() => manager.settings.axis==='vertical' ? Promise.resolve() : originalTrim ? originalTrim() : Promise.resolve();
    }
    queueEpubWindow() {
      if(!this.ready || this.isPdf || this.fixed || !this.rendition || this.reflowing || this.anchorBusy) return;
      const manager=this.rendition.manager;if(!manager || manager.settings.axis!=='vertical') return;
      if(this.epubWindowTask) {this.epubWindowDirty=true;return;}
      const token=this.token;this.epubWindowDirty=false;
      manager.settings.offset=Math.max(1800,this.ui.viewport.clientHeight*3);
      const task=manager.q.enqueue(() => {manager.scrollTop=manager.container.scrollTop;manager.scrollLeft=manager.container.scrollLeft;return manager.check();});this.epubWindowTask=task;
      task.catch(() => {}).finally(() => {
        if(this.epubWindowTask!==task) return;
        this.epubWindowTask=null;
        if(this.token!==token || !this.isConnected || this.reflowing) return;
        this.queueReadingPosition();
        if(this.epubWindowDirty) {this.epubWindowDirty=false;this.queueEpubWindow();}
      });
    }
    stopScreenScroll() {
      const motion=this.screenMotion;if(!motion) return;
      this.screenMotion=null;cancelAnimationFrame(motion.frame);
      motion.box.scrollTo({left:motion.box.scrollLeft,top:motion.box.scrollTop,behavior:'instant'});motion.resolve();
    }
    scrollScreen(direction) {
      const box=this.isPdf ? this.ui.viewport : this.rendition && this.rendition.manager && this.rendition.manager.container;
      if(!box) return Promise.resolve();
      this.stopScreenScroll();this.alignedAnchor=null;this.pdfAlignedAnchor=null;
      const rect=this.ui.viewport.getBoundingClientRect(),visible=this.visibleReaderBounds();
      let top=Math.max(rect.top,visible.top),bottom=Math.min(rect.bottom,visible.bottom);
      if(this.full && this.menuOpen && !this.isPdf) top=Math.max(top,this.ui.top.getBoundingClientRect().bottom);
      const height=Math.max(40,Math.min(box.clientHeight,bottom-top));
      const distance=(direction==='prev' ? -1 : 1)*height*.85,token=this.token;
      let resolve;const promise=new Promise(done => {resolve=done;});
      const motion={box,resolve,frame:null};this.screenMotion=motion;
      box.scrollBy({top:distance,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      let previous=box.scrollTop,quiet=0;const deadline=performance.now()+1400;
      const tick=() => {
        if(this.screenMotion!==motion) return;
        if(this.token!==token || !this.ready || this.reflowing) {this.stopScreenScroll();return;}
        const at=box.scrollTop;quiet=Math.abs(at-previous)<.25 ? quiet+1 : 0;previous=at;
        if(quiet>=6 || performance.now()>deadline) {
          this.screenMotion=null;
          if(this.isPdf) this.queuePdfScroll();else {this.queueEpubWindow();this.queueReadingPosition();}
          resolve();return;
        }
        motion.frame=requestAnimationFrame(tick);
      };
      motion.frame=requestAnimationFrame(tick);
      if(this.isPdf) this.paintPdfWindow();else this.queueEpubWindow();
      return promise;
    }
    unlockFullscreenAncestors() {
      this.fullscreenStyles=[];
      for(let element=this.shell.parentElement;element;element=element.parentElement) {
        const properties={transform:'none',filter:'none','backdrop-filter':'none',perspective:'none',contain:'none','content-visibility':'visible','will-change':'auto',isolation:'auto'};
        if(element!==document.body && element!==document.documentElement) {
          properties['overflow-x']='visible';properties['overflow-y']='visible';properties['z-index']='2147483646';
          if(getComputedStyle(element).position==='static') properties.position='relative';
        }
        const saved=[];
        for(const [name,value] of Object.entries(properties)) {
          saved.push([name,element.style.getPropertyValue(name),element.style.getPropertyPriority(name)]);element.style.setProperty(name,value,'important');
        }
        this.fullscreenStyles.push([element,saved]);
      }
    }
    restoreFullscreenAncestors() {
      for(const [element,saved] of this.fullscreenStyles||[]) for(const [name,value,priority] of saved) {
        if(value) element.style.setProperty(name,value,priority);else element.style.removeProperty(name);
      }
      this.fullscreenStyles=null;
    }
    async paintVisiblePdfPages() {
      const doc=this.pdf,epoch=this.pdfPaintEpoch;if(!this.pdfPages) return;
      const box=this.ui.viewport,top=box.scrollTop,bottom=top+box.clientHeight;
      for(const item of this.pdfPages) {
        if(this.pdf!==doc || this.pdfPaintEpoch!==epoch) return;
        const bounds=this.pdfPageBounds(item);
        if(bounds.top+item.height>top && bounds.top<bottom) await this.paintPdfPage(item);
      }
    }

    async selectBook(button) {
      if (this.navigating || this.switching || this.entering || this.reflowing) return;
      const source = button.dataset.bookSource;
      if (source === this.dataset.source && (this.ready || this.loading)) return;
      this.switching = true;
      try {
        this.savePosition();
        if (this.full) await this.exitFullscreen();
        if (this.full || !this.isConnected) return;
        this.token = null;
        if (this.request) this.request.abort();
        this.destroyBook();
        this.storageKey = null; this.size = null;
        this.loading = false; this.navigating = false;
        this.dataset.source = source;
        this.recordKey=this.bookKeys && this.bookKeys.get(source);
        this.bookIndex = button.dataset.bookIndex;
        this.ui.theme.value = 'light';
        this.ui.workspace.hidden = false;
        this.ui.intro.hidden = false;
        this.ui.start.disabled = false;
        this.ui.start.textContent = this.text('ui_13');
        this.ui.controls.disabled = true;
        this.ui.toc.replaceChildren(new Option(this.text('ui_14'),''));
        this.updateReadingLabel();
        this.updateButtons();
        this.shell.querySelectorAll('[data-book-source]').forEach(el => {
          el.setAttribute('aria-pressed',String(el.dataset.bookIndex === this.bookIndex));
        });
        await this.start();
      } finally {this.switching = false;}
    }
    message(text,error=false) {
      this.ui.status.textContent = text;
      this.ui.status.dataset.error = String(error);
    }
    async start() {
      if (this.loading || this.ready) return;
      if(this.recordReady) await this.recordReady;
      if(this.loading || this.ready || !this.isConnected) return;
      this.loading = true; this.ui.start.disabled = true;
      this.shell.classList.add('er-loading');
      this.ui.start.textContent = this.text('ui_16');
      this.shell.setAttribute('aria-busy','true');
      const token = {}; this.token = token;
      const alive = () => this.isConnected && this.token === token;
      let timer;
      this.loadStage = 'FILE-URL';
      this.message(this.text('ui_17'));
      try {
        const url = new URL(this.dataset.source,location.href);
        if (!['https:','http:'].includes(url.protocol) || (location.protocol === 'https:' && url.protocol !== 'https:')) throw new Error(this.text('ui_18'));
        try {this.recordKey=await MemberContentRecords.contentKey(this.dataset.product,url.href);} catch(_) {}
        this.loadStage = 'FILE-FETCH';
        this.request = new AbortController();
        const request = this.request;
        timer = setTimeout(() => request.abort(),60000);
        const response = await fetch(url.href,{signal:request.signal,credentials:'same-origin'});
        if (!response.ok) throw new Error([401,403].includes(response.status) ? this.text('ui_19') : this.text('ui_http', {status:response.status}));
        this.loadStage = 'FILE-BODY';
        const buffer = await response.arrayBuffer(); clearTimeout(timer);
        if (!alive()) return;
        this.loadStage = 'FILE-TYPE';
        const header = new TextDecoder('latin1').decode(buffer.slice(0,1024));
        if (header.includes('%PDF-')) {
          await this.openPdf(buffer,alive);
        } else {
        this.loadStage = 'EPUB-LIB';
        await loadDependencies(this.text.bind(this)); if (!alive()) return;
        this.setFormat(false);
        const signature = new Uint8Array(buffer,0,Math.min(2,buffer.byteLength));
        if (signature[0] !== 0x50 || signature[1] !== 0x4b) throw new Error(this.text('ui_20'));
        this.loadStage = 'EPUB-OPEN';
        const book = window.ePub(); this.book = book;
        await limitTime(book.open(buffer,'binary'),30000,this.text('ui_21'));
        if (!alive()) return;
        this.setReaderStorageKey('epub');
        this.bookEvents=new AbortController();
        const metadata = book.packaging.metadata;
        this.rtl = metadata.direction === 'rtl';
        this.fixed = metadata.layout === 'pre-paginated';
        this.shell.classList.toggle('er-flow',!this.fixed);
        this.ui.prev.textContent=this.fixed ? this.text('ui_32') : this.readingText('previous');
        this.ui.next.textContent=this.fixed ? this.text('ui_31') : this.readingText('next');
        this.ui['font-controls'].hidden = false;
        this.ui.workspace.hidden = false;
        // Reflowable EPUB scrolls continuously; fixed-layout EPUB retains its original pages.
        this.rendition = book.renderTo(this.ui.viewport,{
          width:this.ui.viewport.clientWidth,height:this.ui.viewport.clientHeight,spread:'none',overflow:this.fixed ? 'hidden' : 'auto',ignoreClass:this.lineClass(),resizeOnOrientationChange:false,
          flow:this.fixed ? 'paginated' : 'scrolled-continuous',manager:this.fixed ? 'default' : 'continuous',
          allowScriptedContent:false,allowPopups:false
        });
        this.rendition.on('relocated',value => {if(alive()) this.relocated(value);});
        this.rendition.on('keydown',event => this.key(event));
        this.rendition.on('attached',() => {
          if(!alive()) return;
          this.setupEpubWindow();
          const container=this.rendition && this.rendition.manager && this.rendition.manager.container;
          if(container) container.addEventListener('scroll',() => {this.queueEpubWindow();this.queueReadingPosition();},{passive:true,signal:this.bookEvents.signal});
        });
        this.rendition.hooks.content.register(contents => {
        if(!alive()) return;
        contents.on('resize',() => {this.queueEpubWindow();this.queueReadingPosition();});
        if(!this.fixed) this.bindContinuousContents(contents);
        contents.document.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        }, true);
        });
        this.restoreSettings();
        this.applyTheme();
        this.rendition.themes.fontSize(this.font + 'px');
        this.updateFont();
        const navigation = await limitTime(book.loaded.navigation,15000,this.text('ui_22'));
        if (!alive()) return;
        this.buildToc(navigation.toc || []);
        const saved = this.readPosition();
        this.shell.classList.add('er-expanded');
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        try {
          await limitTime(this.displayEpubAnchor(saved),20000,this.text('ui_23'));
        } catch(error) {
          if (!saved || !alive() || error.readerAssets) throw error;
          this.cfiAnchor=null;this.currentAnchor=null;
          await limitTime(this.displayEpubAnchor(),20000,this.text('ui_23'));
        }
        if (!alive()) return;
        }
        if (!alive()) return;
        this.shell.classList.add('er-expanded');
        this.ready = true; this.pendingBookmark=null; this.ui.controls.disabled = false; this.ui.intro.hidden = true;
        if(!this.isPdf) this.startProgressIndex();else {this.paintPdfWindow();this.queuePdfScroll();}
        this.message(!this.isPdf && !this.fixed ? this.readingText('hint') : this.text(this.isPdf ? 'pdf_drag_hint' : 'ui_24'));
        this.updateButtons();
        this.size = [this.ui.viewport.clientWidth,this.ui.viewport.clientHeight];

        this.queueReadingPosition();
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.scheduleResize());
          this.observer.observe(this.ui.viewport);
        }
      } catch(error) {
        if (!alive()) return;
        this.destroyBook(); this.ui.workspace.hidden = false; this.ui.intro.hidden = false;
        this.ui.start.textContent = this.text('ui_25');
        const stage = this.loadStage || 'READER';
        const detail = String(error && error.message || error).replace(/https?:\/\/[^\s"'<>]+/g,'[URL]').slice(0,220);
        const key = error.name === 'AbortError' ? 'ui_26' : stage === 'PDF-LIB' ? 'pdf_library_error' : stage.startsWith('PDF-') ? 'pdf_open_error' : 'ui_27';
        this.message(this.text(key) + ' [' + stage + '] ' + detail,true);
        console.error('[Member reader][' + stage + ']', error);
      } finally {
        clearTimeout(timer);
        if (this.token === token) {this.loading = false;this.ui.start.disabled = false;this.shell.classList.remove('er-loading');this.shell.setAttribute('aria-busy','false');}
      }
    }
    setFormat(pdf) {
      this.isPdf = pdf;
      if(pdf) {this.shell.classList.remove('er-flow');this.ui.prev.textContent=this.readingText('previous');this.ui.next.textContent=this.readingText('next');}
      if(this.progressForm) this.cancelProgressEdit();
      this.ui.location.disabled=true;
      if(this.pdfWidth) this.pdfWidth.hidden = !pdf;
      this.shell.classList.toggle('er-pdf',pdf);
      this.ui.toc.parentElement.querySelector('span').textContent = this.text(pdf ? 'pdf_page_label' : 'ui_55');
      this.ui.toc.setAttribute('aria-label',this.text(pdf ? 'pdf_select_page' : 'ui_28'));
      this.ui['font-down'].textContent = pdf ? '−' : 'A−';
      this.ui['font-up'].textContent = pdf ? '＋' : 'A＋';
      this.ui['font-down'].setAttribute('aria-label',this.text(pdf ? 'pdf_zoom_out' : 'ui_41'));
      this.ui['font-up'].setAttribute('aria-label',this.text(pdf ? 'pdf_zoom_in' : 'ui_42'));
      this.ui.reset.textContent = this.text(pdf ? 'pdf_fit' : 'ui_56');
    }
    async openPdf(buffer,alive) {
      this.loadStage = 'PDF-LIB';
      const lib = await loadPdfDependencies(this.text.bind(this)); if (!alive()) return;
      this.setFormat(true); this.rtl = false; this.zoom = 1; this.pdfFit = 'width';
      this.setReaderStorageKey('pdf');
      this.loadStage = 'PDF-OPEN';
      this.pdfTask = lib.getDocument({data:new Uint8Array(buffer),isEvalSupported:false,
        cMapUrl:pdfBase+'cmaps/',cMapPacked:true,standardFontDataUrl:pdfBase+'standard_fonts/'});
      const pdf = await limitTime(this.pdfTask.promise,45000,this.text('pdf_parse'));
      if (!alive()) return;
      this.pdf = pdf;
      let page = 1;
      if (this.remember) try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if (saved) {
          page = Number(saved.page) || 1;
          this.pdfFit = saved.fit === 'page' ? 'page' : 'width';
          this.zoom = saved.fit ? Math.max(.5,Math.min(3,Number(saved.zoom)||1)) : 1;
          if (['light','sepia','dark'].includes(saved.theme)) this.ui.theme.value = saved.theme;
        }
      } catch (_) {}
      const remembered=this.savedReaderPosition('pdf');if(remembered) page=Number(remembered.page)||1;
      this.ui.toc.replaceChildren(); this.ui.toc.disabled = false;
      const options = document.createDocumentFragment();
      for(let n=1;n<=this.pdf.numPages;n++) options.appendChild(new Option(this.text('pdf_page',{number:n}),String(n)));
      this.ui.toc.appendChild(options);
      this.rendition = {
        display:page => this.renderPdf(Number(page)),
        prev:() => this.renderPdf(this.pdfPage-1), next:() => this.renderPdf(this.pdfPage+1),
        resize:() => {this.renderPdf(this.pdfPage,{preserve:true}).catch(error => this.message(this.text('pdf_render_error'),true));},
        destroy:() => {}
      };
      this.ui.workspace.hidden = false;
      this.ui.intro.hidden = true;
      this.shell.classList.add('er-expanded');
      this.applyTheme(); this.updateFont();
      this.loadStage = 'PDF-RENDER';
      // Wait until the expanded reading area has its final layout before the first page.
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (!alive()) return;
      await this.renderPdf(page,{position:remembered});
    }
    pdfAnchor(value) {
      if(!value || !this.pdf) return null;
      return {page:Math.max(1,Math.min(this.pdf.numPages,Math.trunc(Number(value.page))||1)),
        x:Math.max(0,Math.min(1,Number(value.x)||0)),y:Math.max(0,Math.min(1,Number(value.y)||0)),...(value.atEnd===true ? {atEnd:true} : {})};
    }
    pdfPageBounds(item) {
      const box=this.ui.viewport.getBoundingClientRect(),rect=item.node.getBoundingClientRect();
      return {top:rect.top-box.top+this.ui.viewport.scrollTop,left:rect.left-box.left+this.ui.viewport.scrollLeft,width:item.width,height:item.height};
    }
    readPdfPosition() {
      if(!this.pdf || !this.pdfPages || !this.pdfPages.length) return null;
      if(this.pdfLayoutBusy || this.reflowing) return this.pdfAnchor(this.layoutAnchor || this.pdfPositionCache || {page:this.pdfPage||1});
      const box=this.ui.viewport,rect=box.getBoundingClientRect(),visible=this.visibleReaderBounds();
      if(Math.min(rect.bottom,visible.bottom)<=Math.max(rect.top,visible.top) || Math.min(rect.right,visible.right)<=Math.max(rect.left,visible.left)) return this.pdfAnchor(this.pdfPositionCache || {page:this.pdfPage||1});
      const inset=Math.max(0,visible.top-rect.top),leftInset=Math.max(0,visible.left-rect.left);
      const aligned=this.pdfAlignedAnchor;
      if(aligned && Math.abs(box.scrollTop-aligned.top)<1.5 && Math.abs(box.scrollLeft-aligned.left)<1.5 && Math.abs(inset-aligned.inset)<1.5) return this.pdfAnchor(aligned.pos);
      this.pdfAlignedAnchor=null;
      const top=box.scrollTop+inset;let lo=0,hi=this.pdfPages.length;
      while(lo<hi) {const mid=(lo+hi)>>1,bounds=this.pdfPageBounds(this.pdfPages[mid]);if(bounds.top+bounds.height<=top+.5) lo=mid+1;else hi=mid;}
      const item=this.pdfPages[Math.min(lo,this.pdfPages.length-1)],bounds=this.pdfPageBounds(item);
      const atEnd=box.scrollTop+box.clientHeight>=box.scrollHeight-2 && visible.bottom>=rect.bottom-1;
      const pos=this.pdfAnchor({page:item.number,x:(box.scrollLeft+leftInset-bounds.left)/bounds.width,y:(top-bounds.top)/bounds.height,atEnd});
      this.pdfPositionCache=pos;this.pdfPage=pos.page;return pos;
    }
    pdfAnchorAtPercentage(value) {
      if(!this.pdf || !Number.isFinite(value) || value<0 || value>100) return null;
      const offset=value/100*this.pdf.numPages,index=Math.min(this.pdf.numPages-1,Math.floor(offset));
      return this.pdfAnchor({page:index+1,x:0,y:value===100 ? 1 : offset-index,atEnd:value===100});
    }
    async preparePdfPages() {
      const doc=this.pdf;if(!doc || this.pdfPages) return;
      if(this.pdfPreparing) return this.pdfPreparing;
      const task=(async () => {
        const pages=new Array(doc.numPages);let next=1;
        const worker=async () => {
          while(next<=doc.numPages && this.pdf===doc && this.isConnected) {
            const number=next++,proxy=await doc.getPage(number);if(this.pdf!==doc) return;
            const base=proxy.getViewport({scale:1});pages[number-1]={number,proxy,base,ready:false,failed:false};
            if(number%8===0) await new Promise(resolve => setTimeout(resolve,0));
          }
        };
        await limitTime(Promise.all(Array.from({length:Math.min(4,doc.numPages)},worker)),45000,this.text('pdf_parse'));
        if(this.pdf!==doc || !this.isConnected) return;
        const host=document.createElement('div');host.className='er-pdf-pages';
        for(const item of pages) {
          item.node=document.createElement('div');item.node.className='er-pdf-page';item.node.dataset.pdfPage=String(item.number);
          item.node.setAttribute('aria-label',this.text('pdf_page',{number:item.number}));host.appendChild(item.node);
        }
        this.pdfPages=pages;this.pdfPagesHost=host;this.ui.viewport.replaceChildren(host);
      })();
      this.pdfPreparing=task;
      try {await task;} finally {if(this.pdfPreparing===task) this.pdfPreparing=null;}
    }
    cancelPdfPaints() {
      this.pdfPaintEpoch=(this.pdfPaintEpoch||0)+1;this.pdfWindowTask=null;
      for(const item of this.pdfPages||[]) {
        if(item.task) {try {item.task.cancel();} catch(_) {}}
        if(item.canvas) {item.canvas.width=0;item.canvas.height=0;item.canvas.remove();}
        item.task=null;item.promise=null;item.canvas=null;item.ready=false;item.failed=false;
      }
    }
    async paintPdfPage(item) {
      if(item.ready) return;
      if(item.promise) return item.promise;
      const doc=this.pdf,epoch=this.pdfPaintEpoch;
      const current=() => this.pdf===doc && this.pdfPaintEpoch===epoch && this.isConnected;
      const task=(async () => {
        const viewport=item.proxy.getViewport({scale:item.scale}),ratio=Math.min(window.devicePixelRatio||1,2,Math.sqrt(8000000/(viewport.width*viewport.height)),8192/Math.max(viewport.width,viewport.height));
        const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.floor(viewport.width*ratio));canvas.height=Math.max(1,Math.floor(viewport.height*ratio));
        canvas.style.width=viewport.width+'px';canvas.style.height=viewport.height+'px';canvas.setAttribute('role','img');canvas.setAttribute('aria-label','PDF '+this.text('pdf_page',{number:item.number}));
        item.canvas=canvas;item.node.replaceChildren(canvas);item.node.setAttribute('aria-busy','true');
        const context=canvas.getContext('2d');if(!context) throw new Error(this.text('pdf_render_error'));
        item.task=item.proxy.render({canvasContext:context,viewport,transform:ratio===1?null:[ratio,0,0,ratio,0,0]});
        try {await item.task.promise;} catch(error) {if(error.name==='RenderingCancelledException') return;throw error;}
        if(current() && item.canvas===canvas) {item.ready=true;item.node.setAttribute('aria-busy','false');}
      })();
      item.promise=task;
      try {await task;} catch(error) {
        if(current()) {item.failed=true;item.ready=false;throw error;}
      } finally {if(item.promise===task) {item.promise=null;item.task=null;}}
    }
    paintPdfWindow() {
      if(!this.pdfPages || !this.ready || this.pdfLayoutBusy || this.reflowing || this.pdfWindowTask) return;
      const doc=this.pdf,epoch=this.pdfPaintEpoch;let painted=false;
      const task=(async () => {
        while(this.pdf===doc && this.pdfPaintEpoch===epoch && this.ready && !this.pdfLayoutBusy && !this.reflowing) {
          const box=this.ui.viewport,from=box.scrollTop-box.clientHeight,to=box.scrollTop+box.clientHeight*2;
          const wanted=[];
          for(const item of this.pdfPages) {
            const bounds=this.pdfPageBounds(item),near=bounds.top+bounds.height>=from && bounds.top<=to;
            if(near) wanted.push(item);
            else if(item.canvas) {
              if(item.task) item.task.cancel();item.canvas.width=0;item.canvas.height=0;item.canvas.remove();item.canvas=null;item.ready=false;
              if(!item.promise) {try {item.proxy.cleanup();} catch(_) {}}
            }
          }
          wanted.sort((a,b) => Math.abs(a.number-this.pdfPage)-Math.abs(b.number-this.pdfPage));
          const next=wanted.find(item => !item.ready && !item.failed && !item.promise);
          if(!next) break;
          try {await this.paintPdfPage(next);painted=true;} catch(_) {if(this.pdf===doc) this.message(this.text('pdf_render_error'),true);}
        }
      })();
      this.pdfWindowTask=task;
      task.finally(() => {if(this.pdfWindowTask===task) {this.pdfWindowTask=null;if(painted) this.queuePdfScroll();}}).catch(() => {});
    }
    queuePdfScroll() {
      if(!this.isPdf || !this.ready || this.pdfLayoutBusy || this.reflowing || this.navigating || this.restorationFailed) return;
      cancelAnimationFrame(this.pdfScrollFrame);
      this.pdfScrollFrame=requestAnimationFrame(() => {
        this.pdfScrollFrame=null;
        if(!this.isPdf || !this.ready || this.pdfLayoutBusy || this.reflowing || this.navigating || this.restorationFailed) return;
        const pos=this.readPdfPosition();if(!pos) return;
        this.pdfPage=pos.page;this.ui.toc.value=String(pos.page);this.position={atStart:pos.page===1,atEnd:pos.page===this.pdf.numPages};
        this.updateButtons();this.paintPdfWindow();
        clearTimeout(this.pdfSaveTimer);
        if(this.pdfPages[pos.page-1].ready) this.pdfSaveTimer=setTimeout(() => this.savePosition(),120);
      });
    }
    fitPdf(mode) {
      if(!this.isPdf || !this.ready || this.navigating) return;
      this.pdfFit=mode;this.zoom=1;this.updateFont();this.navigate(() => this.renderPdf(this.pdfPage,{preserve:true}));
    }
    async renderPdf(number,options={}) {
      const doc=this.pdf,token=this.token;if(!doc) return;
      const serial=this.pdfSerial=(this.pdfSerial||0)+1;
      const current=() => this.pdf===doc && this.token===token && this.pdfSerial===serial && this.isConnected;
      const target=this.pdfAnchor(options.position || (options.preserve ? this.readPdfPosition() : null) || {page:number});
      let complete=false;
      this.pdfLayoutBusy=true;this.concealLayout();
      try {
        await this.preparePdfPages();if(!current() || !this.pdfPages) return;
        const box=this.ui.viewport,deadline=Date.now()+3000;
        while(box.clientWidth<2 || box.clientHeight<2) {if(!current()) return;if(Date.now()>deadline) throw new Error(this.text('pdf_render_error'));await new Promise(resolve => setTimeout(resolve,50));}
        const key=[box.clientWidth,box.clientHeight,this.pdfFit,this.zoom].join(':');
        if(key!==this.pdfLayoutKey) {
          this.cancelPdfPaints();this.pdfLayoutKey=key;
          let width=Math.max(1,box.clientWidth-16);
          for(const item of this.pdfPages) {
            const fitWidth=Math.max(1,box.clientWidth-16)/item.base.width;
            const fit=this.pdfFit==='page' ? Math.min(fitWidth,Math.max(1,box.clientHeight-16)/item.base.height) : fitWidth;
            item.scale=fit*this.zoom;item.width=item.base.width*item.scale;item.height=item.base.height*item.scale;
            item.node.style.width=item.width+'px';item.node.style.height=item.height+'px';width=Math.max(width,item.width);
          }
          this.pdfPagesHost.style.width=width+'px';
          await new Promise(resolve => requestAnimationFrame(resolve));if(!current()) return;
        }
        const item=this.pdfPages[target.page-1],bounds=this.pdfPageBounds(item),visible=this.visibleReaderBounds(),rect=box.getBoundingClientRect();
        const inset=Math.max(0,visible.top-rect.top);
        box.scrollLeft=Math.max(0,bounds.left+target.x*bounds.width-Math.max(0,visible.left-rect.left));
        box.scrollTop=target.atEnd ? box.scrollHeight-box.clientHeight : Math.max(0,bounds.top+target.y*bounds.height-inset);
        item.failed=false;await this.paintPdfPage(item);if(!current()) return;
        if(!item.ready) throw new Error(this.text('pdf_render_error'));
        await this.paintVisiblePdfPages();if(!current()) return;
        this.pdfPage=target.page;this.pdfPositionCache=target;
        this.pdfAlignedAnchor={pos:target,top:box.scrollTop,left:box.scrollLeft,inset};
        this.position={atStart:target.page===1,atEnd:target.page===doc.numPages};this.ui.toc.value=String(target.page);this.updateButtons();
        complete=true;
      } finally {
        if(current()) {
          this.pdfLayoutBusy=false;
          if(!this.ready) this.shell.classList.remove('er-layout-pending');
          if(complete && !this.reflowing && !this.navigating) {this.savePosition();if(this.ready) this.finishLayout();}
          if(complete) this.paintPdfWindow();
        }
      }
    }
    buildToc(items) {
      this.chapterLinks=[];
      this.ui.toc.replaceChildren();
      this.ui.toc.add(new Option(items.length ? this.text('ui_28') : this.text('ui_29'),''));
      const append = (entries,depth) => entries.forEach(item => {
        if (item.href) {
          const label=String(item.label || this.text('ui_30')).trim();this.chapterLinks.push({href:item.href,label});
          this.ui.toc.add(new Option('　'.repeat(Math.min(depth,5)) + label,item.href));
        }
        if (item.subitems) append(item.subitems,depth+1);
      });
      append(items,0); this.ui.toc.disabled = this.ui.toc.options.length < 2;
    }
    relocated(value) {
      if (!this.isConnected || !this.book || this.reflowing || this.anchorBusy || this.restorationFailed) return;
      if(this.ready && this.size && !this.sameReaderSize(this.size,this.readerSize())) {this.scheduleResize();return;}
      this.position = value;

      if (value.start) {
        this.updateReadingLabel(value);
        const href = String(value.start.href || '').split('#')[0];
        const match = Array.from(this.ui.toc.options).find(option => option.value && option.value.split('#')[0] === href);
        this.ui.toc.value = match ? match.value : '';
        this.savePosition();
      }
      this.updateButtons();
    }
    updateButtons() {
      const busy=!this.ready || this.navigating || this.reflowing;
      if(this.recordTools) this.recordTools.ready(!busy);
      const box=this.isPdf ? this.ui.viewport : null;
      const prev=busy || (box ? box.scrollTop<=.5 : Boolean(this.position && this.position.atStart));
      const next=busy || (box ? box.scrollTop+box.clientHeight>=box.scrollHeight-.5 : Boolean(this.position && this.position.atEnd));
      this.ui.prev.disabled=prev;this.ui.next.disabled=next;
      this.ui.left.disabled=this.rtl ? next : prev;this.ui.right.disabled=this.rtl ? prev : next;
      this.ui.left.setAttribute('aria-label',this.rtl ? this.text('ui_31') : this.text('ui_32'));
      this.ui.right.setAttribute('aria-label',this.rtl ? this.text('ui_32') : this.text('ui_31'));
      this.updateReadingLabel();
    }
    async navigate(action) {
      if(!this.ready || this.navigating || this.reflowing) return;
      this.stopScreenScroll();
      this.navigating=true;this.ui.controls.disabled=true;
      this.ui.viewport.setAttribute('aria-busy','true');this.updateButtons();
      this.concealLayout();
      try {await action();this.restorationFailed=false;this.savePosition();}
      catch(_) {this.restorationFailed=true;if(this.isConnected) this.message(this.text('ui_33'),true);}
      finally {
        this.navigating=false;
        if(this.isConnected) {
          this.ui.controls.disabled=false;this.ui.viewport.setAttribute('aria-busy','false');this.updateButtons();
          this.finishLayout();
        }
      }
    }
    move(direction) {
      if(!this.rendition || !this.ready || this.navigating || this.reflowing) return Promise.resolve();
      if(this.fixed && !this.isPdf) return this.navigate(() => this.rendition[direction]());
      return this.scrollScreen(direction);
    }
    key(event) {
      if(event.key === 'Escape' && this.full) {
        event.preventDefault(); this.exitFullscreen(); return;
      }
      if (event.key === 'Tab' && this.full) {
        // Keep keyboard navigation in the full-screen reader, including CSS fallback.
        const items = Array.from(this.shell.querySelectorAll('button,select,input,[tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const index = items.indexOf(document.activeElement);
        if(items.length && (index === -1 || (event.shiftKey ? index === 0 : index === items.length-1))) {
          event.preventDefault(); items[event.shiftKey ? items.length-1 : 0].focus();
        }
        return;
      }
      if(event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
      if(event.target.closest && event.target.closest('input,textarea,select,button,a,[contenteditable],.er-records')) return;
      if(!this.ready || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.move((this.rtl ? event.key === 'ArrowLeft' : event.key === 'ArrowRight') ? 'next' : 'prev');
    }
    changeFont(delta) {
      if(!this.ready || this.navigating) return;
      if(this.isPdf) {this.zoom = Math.max(.5,Math.min(3,Math.round((this.zoom + (delta>0 ? .25 : -.25))*100)/100));this.updateFont();this.navigate(() => this.renderPdf(this.pdfPage,{preserve:true}));return;}
      this.font = Math.max(14,Math.min(32,(this.font || Number(this.dataset.font) || 18)+delta));
      this.beginLayoutChange();this.rendition.themes.fontSize(this.font + 'px'); this.updateFont(); this.scheduleResize(true);
    }
    resetFont() {
      if(!this.ready || this.navigating) return;
      if(this.isPdf) {this.fitPdf('page');return;}
      this.font = Number(this.dataset.font) || 18;
      this.beginLayoutChange();this.rendition.themes.fontSize(this.font + 'px');
      this.updateFont(); this.scheduleResize(true);
    }
    updateFont() {
      const zoomed = Boolean(this.isPdf && this.zoom > 1);
      this.shell.classList.toggle('er-pdf-zoomed',zoomed);
      if(this.pdfWidth) this.pdfWidth.hidden = !this.isPdf;
      if(this.isPdf) {
        this.ui['font-value'].textContent = Math.round(this.zoom*100)+'%';
        this.ui['font-down'].disabled = this.zoom<=.5;
        this.ui['font-up'].disabled = this.zoom>=3;
        this.ui.reset.disabled = this.pdfFit==='page' && this.zoom===1;
        if(this.pdfWidth) this.pdfWidth.disabled = this.pdfFit==='width' && this.zoom===1;
        return;
      }
      this.shell.style.setProperty('--er-hint-font',this.font + 'px');
      this.ui['font-value'].textContent = this.font + 'px';
      this.ui['font-down'].disabled = this.font <= 14;
      this.ui['font-up'].disabled = this.font >= 32;
      this.ui.reset.disabled = this.font === (Number(this.dataset.font) || 18);
    }
    applyTheme() {
      if(!this.rendition) return;
      const palettes = {
        light:{background:'#ffffff',text:'#202934',link:'#1659a5'},
        sepia:{background:'#f6efdf',text:'#433a2e',link:'#72501e'},
        dark:{background:'#20252b',text:'#e3e8ee',link:'#96c8ff'}
      };
      const palette = palettes[this.ui.theme.value] || palettes.light;
      this.ui.viewport.style.backgroundColor = palette.background;
      this.ui.viewport.parentElement.style.backgroundColor = palette.background;
      this.shell.style.backgroundColor = palette.background;
      if(this.isPdf) return;
      this.rendition.themes.default({
        'html':{'background':palette.background+' !important'},
        'body':{'background':palette.background+' !important','color':palette.text+' !important','line-height':'1.8 !important','overflow-wrap':'break-word'},
        'p, div, span, li, h1, h2, h3, h4, h5, h6, blockquote':{'color':palette.text+' !important'},
        'a':{'color':palette.link+' !important'},
        'img, svg, video':{'max-width':'100% !important','max-height':'100% !important','object-fit':'contain'}
      });
    }
    restoreSettings() {
      if(!this.remember) return;
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if(saved && Number.isFinite(saved.font)) this.font = Math.max(14,Math.min(32,saved.font));
        if(saved && ['light','sepia','dark'].includes(saved.theme)) this.ui.theme.value = saved.theme;
      } catch(_) {}
    }
    showFullscreenHint() {
      clearTimeout(this.hintTimer);
      this.shell.classList.add('er-show-zones');
      if(this.isPdf) {
        this.ui['full-hint'].replaceChildren();
        ['pdf_hint_title','pdf_hint_fit','pdf_hint_pages'].forEach(key => {
          const line = document.createElement('span');line.textContent = key==='pdf_hint_pages' ? this.readingText('scroll') : this.text(key);
          this.ui['full-hint'].appendChild(line);
        });
      }
      else {this.ui['full-hint'].replaceChildren(document.createTextNode(this.fixed ? this.text('ui_62') : this.readingText('menu')),document.createElement('br'),document.createElement('br'),document.createTextNode(this.fixed ? this.text('ui_63') : this.readingText('scroll')));}
      this.ui['full-hint'].hidden = false;
      this.hintTimer = setTimeout(() => {
        this.ui['full-hint'].hidden = true;
        this.shell.classList.remove('er-show-zones');
      },3000);
    }
    async toggleFullscreen() {
      if(this.full) {await this.exitFullscreen();return;}
      if(!this.ready || this.entering || fullscreenOwner) return;
      this.recordDiagnostic('進入全螢幕前');
      this.beginLayoutChange();
      this.entering = true; fullscreenOwner = this;
      this.shell.style.setProperty('--er-fullscreen-width',this.ui.workspace.clientWidth+'px');
      this.returnFocus = document.activeElement;
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.full = true; this.native = false;
      this.shell.classList.add('er-full');
      this.syncMobileViewport();
      this.ui.center.hidden = this.isPdf; this.ui['fs-hint'].hidden = this.isPdf;
      if(!this.isPdf && !this.fixed) this.ui['fs-hint'].textContent=this.readingText('hint');
      this.ui.fullscreen.textContent = this.text('ui_34');
      this.setMenu(false); (this.isPdf || !this.fixed ? this.ui.viewport : this.ui.center).focus({preventScroll:true});
      const request = this.shell.requestFullscreen || this.shell.webkitRequestFullscreen;
      try {
        if(request) {
          await request.call(this.shell);
          this.native = (document.fullscreenElement || document.webkitFullscreenElement) === this.shell;
        }
      } catch(_) {
        // iPhone / restricted iframe: CSS viewport fullscreen is the fallback.
      } finally {
        if(this.full && !this.native) this.unlockFullscreenAncestors();
        this.entering = false;
        if(!this.isConnected) this.restoreFullscreen();
        else if(this.full) {this.scheduleResize(true);this.showFullscreenHint();}
      }
    }
    setMenu(open) {
      const relayout=this.isPdf && this.full && this.ready && this.menuOpen!==Boolean(open);
      if(relayout) this.beginLayoutChange();
      this.menuOpen = Boolean(open);
      if(this.pdfTopToggle) {
        this.pdfTopToggle.textContent = this.text(this.menuOpen ? 'pdf_hide_top' : 'pdf_show_top');
        this.pdfTopToggle.setAttribute('aria-expanded',String(this.menuOpen));
      }
      this.shell.classList.toggle('er-menu-open',this.menuOpen);
      this.ui.center.setAttribute('aria-expanded',String(this.menuOpen));
      this.ui.center.setAttribute('aria-label',this.menuOpen ? this.text('ui_35') : this.text('ui_36'));
      for(const key of ['top','bottom']) {
        this.ui[key].inert = Boolean(this.full && !this.menuOpen && !((this.isPdf || this.shell.classList.contains('er-flow')) && key === 'bottom'));
      }
      if(relayout) this.scheduleResize(true);
    }
    fullscreenChanged() {
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {this.native = true;return;}
      if(this.full && this.native) this.restoreFullscreen();
    }
    async exitFullscreen() {
      if(!this.full) return;
      this.beginLayoutChange();this.exiting=true;
      const active = document.fullscreenElement || document.webkitFullscreenElement;
      if(active === this.shell) {
        const exit = document.exitFullscreen || document.webkitExitFullscreen;
        try {if(exit) await exit.call(document);} catch(_) {this.exiting=false;this.finishLayout();return;}
      }
      this.restoreFullscreen();
    }
    restoreFullscreen() {
      if(!this.full) return;
      this.beginLayoutChange();this.exiting=false;
      clearTimeout(this.hintTimer); this.ui['full-hint'].hidden = true;
      this.full = false; this.native = false;
      this.syncMobileViewport();
      this.shell.style.removeProperty('--er-fullscreen-width');
      this.shell.classList.remove('er-full','er-menu-open','er-show-zones');
      this.ui.center.hidden = true; this.ui['fs-hint'].hidden = true;
      this.ui.fullscreen.textContent = this.text('ui_37');
      this.setMenu(false);
      this.restoreFullscreenAncestors();
      document.body.style.overflow = this.oldOverflow || '';
      if(fullscreenOwner === this) fullscreenOwner = null;
      if(this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus({preventScroll:true});
      this.returnToReader=true;
      this.scheduleResize(true);
    }
    scheduleResize(force=false) {
      if(!this.ready || !this.rendition || !this.isConnected) return;
      this.syncMobileViewport();
      if(!force && !this.reflowing && this.size && this.sameReaderSize(this.size,this.readerSize())) return;
      this.beginLayoutChange();
      clearTimeout(this.resizeTimer);
      this.resizeTimer=setTimeout(() => {
        this.resizeTimer=null;
        if(!this.ready || !this.rendition || !this.isConnected) return;
        if(this.entering || this.exiting) {this.scheduleResize(true);return;}
        const width=this.ui.viewport.clientWidth,height=this.ui.viewport.clientHeight;
        if(width<1 || height<1) return;
        if(this.resizeTask) {this.queuedResize=[width,height];return;}
        this.size=[width,height];this.resizeReader(width,height);
      },120);
    }
    readPosition() {
      const saved=this.savedReaderPosition('epub');
      this.cfiAnchor=saved && typeof saved.cfi==='string' ? saved.cfi : null;
      this.currentAnchor=this.epubAnchor(saved);
      return this.currentAnchor;
    }
    savePosition() {
      if(!this.remember || !this.storageKey || this.reflowing || this.anchorBusy || this.restorationFailed) return;
      const position=this.readerPosition();if(!position) return;
      try {
        const settings=this.isPdf ? {zoom:this.zoom,fit:this.pdfFit,theme:this.ui.theme.value} : {font:this.font,theme:this.ui.theme.value};
        localStorage.setItem(this.storageKey,JSON.stringify({...position,...settings}));
      } catch(_) {}
      if(this.records && this.ready && this.recordKey) {
        try {this.records.saveProgress(this.isPdf?'pdf':'epub',this.recordKey,position);}
        catch(error) {this.records.notify(error.code||'error');}
      }
    }
    destroyBook() {
      this.stopScreenScroll();clearTimeout(this.epubPruneTimer);
      if(this.bookEvents) this.bookEvents.abort();this.bookEvents=null;
      this.epubManager=null;this.epubDisplays=null;this.epubWindowTask=null;this.epubWindowDirty=false;this.boundEpubDocuments=null;
      cancelAnimationFrame(this.revealFrame);
      cancelAnimationFrame(this.rememberFrame);clearTimeout(this.rememberTimer);
      this.shell.classList.remove('er-layout-pending');
      this.alignedAnchor=null;this.progressIndex=null;this.progressLoading=false;this.chapterLinks=[];
      if(this.progressForm) this.cancelProgressEdit();
      this.pdfSerial = (this.pdfSerial || 0)+1;
      this.cancelPdfPaints();cancelAnimationFrame(this.pdfScrollFrame);clearTimeout(this.pdfSaveTimer);
      this.pdfPages=null;this.pdfPagesHost=null;this.pdfPreparing=null;this.pdfLayoutKey=null;this.pdfLayoutBusy=false;this.pdfAlignedAnchor=null;this.pdfPositionCache=null;
      if(this.pdfTask) {try {Promise.resolve(this.pdfTask.destroy()).catch(() => {});} catch (_) {} this.pdfTask=null;}
      this.pdf=null; this.pdfPage=null; this.zoom=1; this.pdfFit='width'; this.pdfDrag=null;
      if(this.ui) this.ui.viewport.classList.remove('er-dragging');
      if(this.ui) this.setFormat(false);
      clearTimeout(this.hintTimer);
      this.ready = false; this.reflowing=false; this.layoutAnchor=null; this.resizeTask=null; this.queuedResize=null; this.returnToReader=false; this.layoutMoved=false; this.restorationFailed=false; this.cfiAnchor=null; this.currentAnchor=null; this.anchorBusy=false;  this.position = null; this.font = Number(this.dataset.font) || 18;
      if(this.observer) this.observer.disconnect();
      clearTimeout(this.resizeTimer);
      try {if(this.rendition) this.rendition.destroy();} catch(_) {}
      try {if(this.book) this.book.destroy();} catch(_) {}
      this.rendition = null; this.book = null;
      if(this.ui) {this.ui.viewport.replaceChildren();this.updateFont();}
    }
    disconnectedCallback() {
      this.savePosition(); this.token = null;
      if(this.recordTools) {this.recordTools.destroy();this.recordTools=null;}
      cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();
      if(this.request) this.request.abort();
      if(this.ui) {this.restoreFullscreen(); this.destroyBook();}
      this.loading = false; this.navigating = false; this.initialized = false;
    }
  }
  customElements.define('member-product-epub-reader',EpubReader);
})();

(() => {
  if(customElements.get('member-product-bunny-playlist')) return;
  let playerScript;
  function loadPlayerApi() {
    if(window.playerjs && window.playerjs.Player) return Promise.resolve();
    if(!playerScript) playerScript=new Promise((resolve,reject) => {
      const script=document.createElement('script');script.src='https://assets.mediadelivery.net/playerjs/playerjs-latest.min.js';
      const timer=setTimeout(() => {script.remove();reject(new Error('Player API timeout'));},15000);
      script.onload=() => {clearTimeout(timer);window.playerjs && window.playerjs.Player ? resolve() : reject(new Error('Player API unavailable'));};
      script.onerror=() => {clearTimeout(timer);script.remove();reject(new Error('Player API unavailable'));};document.head.appendChild(script);
    }).catch(error => {playerScript=null;throw error;});
    return playerScript;
  }
  const secondsLabel=value => {
    const total=Math.max(0,Math.floor(Number(value)||0)),seconds=String(total%60).padStart(2,'0'),minutes=Math.floor(total/60);
    return minutes>=60 ? Math.floor(minutes/60)+':'+String(minutes%60).padStart(2,'0')+':'+seconds : minutes+':'+seconds;
  };
  class BunnyPlaylist extends HTMLElement {
    text(key,values={}) {
      if(!this.uiStrings) {try {this.uiStrings=JSON.parse(this.dataset.i18n||'{}');} catch(_) {this.uiStrings={};}}
      return String(this.uiStrings[key]??'').replace(/\[(\w+)\]/g,(match,name) => Object.prototype.hasOwnProperty.call(values,name)?String(values[name]):match);
    }
    connectedCallback() {
      if(this.initialized) return;this.initialized=true;
      this.frame=requestAnimationFrame(() => this.setup());
    }
    async setup() {
      if(!this.isConnected) return;
      const frame=this.querySelector('[data-bunny-frame]'),status=this.querySelector('[data-media-status]');
      const buttons=[...this.querySelectorAll('[data-media-path]')];
      const valid=buttons.filter(button => {
        const path=button.dataset.mediaPath.trim();
        const ok=/^\d+\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path);
        button.hidden=!ok;if(ok) button.dataset.mediaPath=path;return ok;
      });
      if(valid.length!==buttons.length) {status.hidden=false;status.textContent=this.text('ui_38');}
      frame.hidden=!valid.length;
      this.querySelector('.mm-playlist').hidden=valid.length<=1;
      this.querySelector('.mm-media-layout').classList.toggle('mm-has-list',valid.length>1);
      this.events=new AbortController();this.frameElement=frame;this.statusElement=status;this.valid=valid;
      valid.forEach((button,index) => {button.textContent=this.text('ui_episode',{number:index+1});button.setAttribute('aria-pressed','false');
        button.addEventListener('click',() => this.select(button),{signal:this.events.signal});});
      const syncHeight=() => {const height=frame.getBoundingClientRect().height;if(height>0) this.style.setProperty('--mm-video-height',height+'px');};
      if(typeof ResizeObserver!=='undefined') {this.sizeObserver=new ResizeObserver(syncHeight);this.sizeObserver.observe(frame);}
      window.addEventListener('resize',syncHeight,{signal:this.events.signal});frame.addEventListener('load',syncHeight,{signal:this.events.signal});syncHeight();
      try {
        this.records=MemberContentRecords.service(this.dataset.recordsConfig);
        this.keys=new Map(await Promise.all(valid.map(async button => [button.dataset.mediaPath,
          await MemberContentRecords.contentKey(this.records.product,'https://player.mediadelivery.net/embed/'+button.dataset.mediaPath)])));
        if(!this.isConnected) return;
        this.recordTools=new MemberContentRecords.Tools(this.querySelector('.mm-player-column'),this.records,{
          bookmarks:this.dataset.manualBookmarks==='true',context:() => this.bookmarkContext(),jump:item => this.openBookmark(item),accept:item => item.kind==='media'
        });
      } catch(_) {this.records=null;}
      let initial=valid[0],latest=null;
      if(this.records && this.keys) for(const button of valid) {
        const saved=this.records.progress('media',this.keys.get(button.dataset.mediaPath));
        if(saved && (!latest || saved.t>latest.t)) {latest=saved;initial=button;}
      }
      if(initial) await this.select(initial);
      document.addEventListener('visibilitychange',() => {if(document.visibilityState==='hidden') this.saveMedia(true);},{signal:this.events.signal});
      window.addEventListener('pagehide',() => this.saveMedia(true),{signal:this.events.signal});
    }
    detachPlayer() {
      if(this.player) {
        for(const event of ['ready','timeupdate','play','pause','ended','seeked','error']) try {this.player.off(event);} catch(_) {}
      }
      this.player=null;this.apiReady=false;this.playing=false;
      if(this.recordTools) this.recordTools.ready(false);
    }
    async select(button,position) {
      if(button.getAttribute('aria-pressed')==='true' && !position) return;
      this.saveMedia(true);this.detachPlayer();
      const generation=this.generation={};this.activeButton=button;
      this.activeKey=this.keys && this.keys.get(button.dataset.mediaPath);this.lastSaved=null;
      const saved=this.records && this.activeKey && this.records.progress('media',this.activeKey);
      const target=position || saved && saved.pos;
      let start=target && Number.isFinite(Number(target.seconds)) ? Math.max(0,Number(target.seconds)) : 0;
      this.timing={seconds:start,duration:Number(target && target.duration)||0};this.restoring=true;
      this.valid.forEach(item => item.setAttribute('aria-pressed',String(item===button)));
      this.frameElement.src='https://player.mediadelivery.net/embed/'+button.dataset.mediaPath+'?autoplay=false&loop=false&muted=false&preload=true&responsive=true'+(this.dataset.iosNativeHls==='true'?'&nativeHls=auto':'')+(start>0?'&t='+encodeURIComponent(start):'');
      this.frameElement.title=this.text('ui_player_title',{title:button.textContent.trim()});
      try {
        await loadPlayerApi();
        if(!this.isConnected || this.generation!==generation) return;
        const player=new playerjs.Player(this.frameElement);this.player=player;
        const current=() => this.isConnected && this.generation===generation;
        player.on('ready',() => {
          if(!current()) return;
          this.apiReady=true;
          player.on('timeupdate',value => {
            if(!current()) return;
            let data=value;try {if(typeof data==='string') data=JSON.parse(data);} catch(_) {return;}
            if(!data || !Number.isFinite(Number(data.seconds))) return;
            const timing={seconds:Math.max(0,Number(data.seconds)),duration:Math.max(0,Number(data.duration)||0)};
            if(this.restoring) {if(Math.abs(timing.seconds-start)>2) return;this.restoring=false;}
            this.timing=timing;
            if(this.recordTools) this.recordTools.ready(true);
            if(this.playing) this.saveMedia(false);
          });
          player.on('play',() => {if(current()) this.playing=true;});
          player.on('pause',() => {if(current()) {this.playing=false;this.saveMedia(true);}});
          player.on('ended',() => {if(current()) this.saveMedia(true);});
          player.on('seeked',() => {
            if(!current() || this.restoring) return;
            player.getCurrentTime(time => {if(current() && Number.isFinite(Number(time))) {this.timing.seconds=Math.max(0,Number(time));this.saveMedia(true);}});
          });
          player.on('error',() => {if(current() && this.records) this.records.notify('player-error');});
          if(start>0) player.setCurrentTime(start);
          player.getDuration(duration => {
            if(!current()) return;
            this.timing.duration=Math.max(0,Number(duration)||0);
            if(this.timing.duration>0 && start>=this.timing.duration) {
              start=Math.max(0,this.timing.duration-.25);player.setCurrentTime(start);
            }
          });
          player.getCurrentTime(time => {
            if(!current() || !Number.isFinite(Number(time))) return;
            if(Math.abs(Number(time)-start)<=2) {this.timing.seconds=Number(time);this.restoring=false;if(this.recordTools) this.recordTools.ready(true);}
          });
        });
      } catch(_) {if(this.records && this.generation===generation) this.records.notify('player-error');}
    }
    saveMedia(force) {
      if(!this.records || !this.activeKey || this.restoring || !this.timing || !this.apiReady) return;
      const seconds=Math.round(this.timing.seconds*10)/10;
      if(!force && this.lastSaved!==null && Math.abs(seconds-this.lastSaved)<5) return;
      try {this.records.saveProgress('media',this.activeKey,{seconds,duration:Math.round(this.timing.duration*10)/10});this.lastSaved=seconds;}
      catch(error) {this.records.notify(error.code||'error');}
    }
    bookmarkContext() {
      if(!this.apiReady || this.restoring || !this.activeKey) return null;
      return {key:this.activeKey,kind:'media',label:this.activeButton.textContent.trim()+'｜'+secondsLabel(this.timing.seconds),
        pos:{seconds:Math.round(this.timing.seconds*10)/10,duration:Math.round(this.timing.duration*10)/10}};
    }
    async openBookmark(item) {
      const button=this.valid.find(button => this.keys.get(button.dataset.mediaPath)===item.key);
      if(!button) throw new Error('Media is no longer listed');
      if(button===this.activeButton && this.player && this.apiReady) {
        this.player.setCurrentTime(Math.max(0,Number(item.pos.seconds)||0));
      } else await this.select(button,item.pos);
    }
    disconnectedCallback() {
      this.saveMedia(true);this.generation=null;this.detachPlayer();
      if(this.sizeObserver) this.sizeObserver.disconnect();cancelAnimationFrame(this.frame);
      if(this.events) this.events.abort();if(this.recordTools) this.recordTools.destroy();this.initialized=false;
    }
  }
  customElements.define('member-product-bunny-playlist',BunnyPlaylist);
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-video-new"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('member-title-video-player')) return;
  class MemberTitleVideoPlayer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.animationFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected) return;
      const frame = this.querySelector('[data-video-frame]');
      const status = this.querySelector('[data-video-status]');
      const nav = this.querySelector('.mvp-playlist');
      const layout = this.querySelector('.mvp-layout');
      const buttons = [...this.querySelectorAll('[data-media-path]')];
      const valid = buttons.filter(button => {
        const path = button.dataset.mediaPath.trim();
        const ok = /^\d+\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path);
        button.hidden = !ok;
        if (ok) button.dataset.mediaPath = path;
        return ok;
      });
      status.hidden = valid.length === buttons.length;
      status.textContent = valid.length === buttons.length ? '' : '部分影音資料格式不正確，請聯絡網站管理員。';
      frame.hidden = valid.length === 0;
      // 單集仍載入第一集，但不顯示清單，也不保留清單欄位空間。
      nav.hidden = valid.length <= 1;
      layout.classList.toggle('mvp-has-list', valid.length > 1);
      this.events = new AbortController();
      const select = button => {
        if (button.getAttribute('aria-pressed') === 'true') return;
        frame.src = 'https://player.mediadelivery.net/embed/' + button.dataset.mediaPath + '?autoplay=false&loop=false&muted=false&preload=true&responsive=true';
        frame.title = '影音播放器：' + button.textContent.trim();
        valid.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      };
      valid.forEach((button, index) => {
        button.textContent = '第 ' + (index + 1) + ' 集';
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => select(button), {signal:this.events.signal});
      });
      const syncHeight = () => {
        const height = frame.getBoundingClientRect().height;
        if (height > 0) this.style.setProperty('--mvp-video-height', height + 'px');
      };
      if (typeof ResizeObserver !== 'undefined') {
        this.sizeObserver = new ResizeObserver(syncHeight);
        this.sizeObserver.observe(frame);
      }
      window.addEventListener('resize', syncHeight, {signal:this.events.signal});
      frame.addEventListener('load', syncHeight, {signal:this.events.signal});
      if (valid.length) select(valid[0]);
      syncHeight();
    }
    disconnectedCallback() {
      if (this.sizeObserver) this.sizeObserver.disconnect();
      cancelAnimationFrame(this.animationFrame);
      if (this.events) this.events.abort();
      this.initialized = false;
    }
  }
  customElements.define('member-title-video-player', MemberTitleVideoPlayer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tea-collection-banners"]) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => {
  const notice = event.target.closest('.tj-banner-editor-target');
  if (notice) { notice.hidden = false; notice.scrollIntoView({ block: 'center' }); }
});
document.addEventListener('shopify:block:deselect', (event) => {
  const notice = event.target.closest('.tj-banner-editor-target');
  if (notice) notice.hidden = true;
});

  } catch(e) { console.error(e); }
})();
})();
